// "use client"
// import { useState, useEffect } from "react"
// import axios from "axios"
// import Swal from "sweetalert2"
// import DashNavbar from "./DashNavbar"
// import Sidebar from "./Sidebar"
// import { useNavigate } from "react-router-dom"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//   faTrash,
//   faPlus,
//   faEdit,
//   faCheck,
//   faTimes,
//   faQuestionCircle,
//   faClipboardList,
//   faArrowLeft,
//   faSave,
//   faInfoCircle,
//   faTasks,
//   faEye,
//   faBuilding,
//   faBan, // For deactivation
// } from "@fortawesome/free-solid-svg-icons"

// const PREDEFINED_RATING_SCALE = ["Exceptional", "Above Average", "Average", "Satisfactory", "Unsatisfactory"]
// const PREDEFINED_AREAS = [
//   { value: "CORE_COMPETENCIES", label: "1. Core Competencies" },
//   { value: "BEHAVIORAL", label: "2. Additional Behavioral & Functional Parameters" },
//   { value: "ROLE_FIT", label: "3. Role-Specific & Cultural Fit" },
// ]

// function CreateQuestions() {
//   const [designMode, setDesignMode] = useState("candidateQuiz")
//   const [jobRole, setJobRole] = useState("")
//   // New state to display posting details
//   const [selectedPostingType, setSelectedPostingType] = useState("")
//   const [selectedPostingId, setSelectedPostingId] = useState("")
//   const [question, setQuestion] = useState("")
//   const [area, setArea] = useState(PREDEFINED_AREAS[0].value)
//   const [description, setDescription] = useState("")
//   const [questionType, setQuestionType] = useState("mcq")
//   const [answers, setAnswers] = useState(["", "", "", ""])
//   const [correct, setCorrect] = useState(0)
//   const [trueOrFalse, setTrueOrFalse] = useState("true")
//   const [questions, setQuestions] = useState([])
//   const [jobRoles, setJobRoles] = useState([])
//   const [isLoading, setIsLoading] = useState(false)
//   const [editingIndex, setEditingIndex] = useState(null)
//   const [editedQuestion, setEditedQuestion] = useState("")
//   const [editedArea, setEditedArea] = useState(PREDEFINED_AREAS[0].value)
//   const [editedDescription, setEditedDescription] = useState("")
//   const [editedQuestionType, setEditedQuestionType] = useState("mcq")
//   const [editedAnswers, setEditedAnswers] = useState(["", "", "", ""])
//   const [editedCorrect, setEditedCorrect] = useState(0)
//   const [editedTrueOrFalse, setEditedTrueOrFalse] = useState("true")

//   // State for evaluation setups
//   const [jobEvaluationSummary, setJobEvaluationSummary] = useState({})
//   const [selectedJobEvaluations, setSelectedJobEvaluations] = useState(null)
//   const [showEvaluationDetails, setShowEvaluationDetails] = useState(false)
//   const [evaluationsLoading, setEvaluationsLoading] = useState(false)

//   // State for evaluation questions and parameters (for CRUD operations)
//   const [evaluationQuestions, setEvaluationQuestions] = useState({})
//   const [evaluationParameters, setEvaluationParameters] = useState({})

//   // Edit states for evaluations
//   const [editingEvaluation, setEditingEvaluation] = useState(null)
//   const [editingEvaluationType, setEditingEvaluationType] = useState(null) // 'general' or 'parameter'
//   const [editEvalForm, setEditEvalForm] = useState({
//     question_text: "",
//     answers: ["", "", "", ""],
//     correct_answer_index: 0,
//     area: "CORE_COMPETENCIES",
//     parameter_text: "",
//     description: "",
//     is_active: true,
//   })

//   const navigate = useNavigate()

//   const initializeAndRefreshData = async () => {
//     setEvaluationsLoading(true)
//     try {
//       // Fetch ACTIVE Job Postings, Business Opportunities and Technical Consultants in a single call
//       const activeResponse = await axios.get("https://raasbackend.vetrinahealthcare.com/JobPostingresultByStatus/?no_cache=1")

//       const activeJobs = Array.isArray(activeResponse?.data?.jobpostings) ? activeResponse.data.jobpostings : []
//       const activeBusiness = Array.isArray(activeResponse?.data?.business_opportunities) ? activeResponse.data.business_opportunities : []
//       const activeConsultants = Array.isArray(activeResponse?.data?.technical_consultants) ? activeResponse.data.technical_consultants : []

//       const jobsData = activeJobs.map((job) => ({
//         value: job.job_id,
//         label: `${job.jobtitle} (Job)`,
//         type: "Job_Opening",
//       }))

//       const businessData = activeBusiness.map((b) => ({
//         value: b.business_id,
//         label: `${b.business_title} (Business)`,
//         type: "Business_Opportunity",
//       }))

//       const consultantsData = activeConsultants.map((c) => ({
//         value: c.consultant_id,
//         label: `${c.title} (Consultant)`,
//         type: "Technical_Consultant",
//       }))

//       const allRolesData = [...jobsData, ...businessData, ...consultantsData]
//       setJobRoles(allRolesData)


//       // 2. Fetch all evaluation setups (questions and parameters) for every job
//       const { questionsData, parametersData } = await fetchAllEvaluationSetups(allRolesData)
//       setEvaluationQuestions(questionsData)
//       setEvaluationParameters(parametersData)

//       // 3. Build the summary for the right-hand panel based on setups
//       buildJobEvaluationSummary(questionsData, parametersData, allRolesData)
//     } catch (error) {
//       console.error("Error initializing data:", error)
//       Swal.fire("Error", "Could not fetch initial job role and evaluation data.", "error")
//     } finally {
//       setEvaluationsLoading(false)
//     }
//   }


//   useEffect(() => {
//     initializeAndRefreshData()
//   }, [])

//   const fetchAllEvaluationSetups = async (allJobs) => {
//     const questionsData = {}
//     const parametersData = {}

//     for (const job of allJobs) {
//       if (!job || !job.value || !job.label) continue

//       try {
//         const url = `https://raasbackend.vetrinahealthcare.com/evaluation_questions/${encodeURIComponent(job.label)}/`
//         const questionsResponse = await axios.get(url)
//         questionsData[job.value] = questionsResponse.data || []
//       } catch (error) {
//         console.warn(`No evaluation questions found for job '${job.label}' or error fetching.`)
//         questionsData[job.value] = []
//       }

//       try {
//         const parametersResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/job-postings/${job.value}/evaluation-parameters/`)
//         parametersData[job.value] = parametersResponse.data || []
//       } catch (error) {
//         console.warn(`No evaluation parameters found for job ID ${job.value} or error fetching.`)
//         parametersData[job.value] = []
//       }
//     }
//     return { questionsData, parametersData }
//   }

//   const buildJobEvaluationSummary = (questionsByJob, parametersByJob, allJobRoles) => {
//     const summary = {}
//     // Use a Set to ensure we only process each unique job/consultant ID once
//     const allIdsWithSetups = new Set([...Object.keys(questionsByJob), ...Object.keys(parametersByJob)]);

//     allIdsWithSetups.forEach((roleId) => {
//         // Find the role details from the combined list of jobs and consultants
//         const roleDetails = allJobRoles.find((role) => role.value === roleId);

//         if (roleDetails) {
//             const generalCount = questionsByJob[roleId]?.length || 0;
//             const parameterCount = parametersByJob[roleId]?.length || 0;

//             if (generalCount > 0 || parameterCount > 0) {
//                 summary[roleId] = {
//                     job_id: roleId, // Keep this key for consistency in the component
//                     job_title: roleDetails.label, // This will now show the full label e.g., "Software Engineer (Job)"
//                     general_question_count: generalCount,
//                     parameter_count: parameterCount,
//                 };
//             }
//         }
//     });
//     setJobEvaluationSummary(summary);
// };


//   const handleEditEvaluation = (evaluation, type) => {
//     if (type !== "parameter") return
//     setEditingEvaluation(evaluation)
//     setEditingEvaluationType(type)
//     setEditEvalForm({
//       question_text: "",
//       answers: ["", "", "", ""],
//       correct_answer_index: 0,
//       area: evaluation.area || "CORE_COMPETENCIES",
//       parameter_text: evaluation.parameter_text || "",
//       description: evaluation.description || "",
//       is_active: evaluation.is_active !== undefined ? evaluation.is_active : true,
//     })
//   }

//   const handleUpdateEvaluation = async () => {
//     if (!editingEvaluation || !selectedJobEvaluations || editingEvaluationType !== "parameter") return
//     setIsLoading(true)
//     try {
//       const jobId = selectedJobEvaluations.job_id
//       const url = `https://raasbackend.vetrinahealthcare.com/job-postings/${jobId}/evaluation-parameters/${editingEvaluation.id}/`
//       const payload = {
//         area: editEvalForm.area,
//         parameter_text: editEvalForm.parameter_text,
//         description: editEvalForm.description,
//         is_active: editEvalForm.is_active,
//       }
//       await axios.put(url, payload)
//       Swal.fire("Success!", "Parameter evaluation updated successfully.", "success")
//       setEditingEvaluation(null)
//       setEditingEvaluationType(null)
//       await initializeAndRefreshData()
//     } catch (error) {
//       console.error("Error updating evaluation:", error)
//       const errorMessage =
//         error.response?.data?.detail || JSON.stringify(error.response?.data) || "Failed to update evaluation"
//       Swal.fire("Error!", errorMessage, "error")
//     } finally {
//       setIsLoading(false)
//     }
//   }

//   const handleToggleParameterActiveStatus = async (parameter, jobId) => {
//     setIsLoading(true)
//     try {
//       const url = `https://raasbackend.vetrinahealthcare.com/job-postings/${jobId}/evaluation-parameters/${parameter.id}/`
//       const payload = {
//         area: parameter.area,
//         parameter_text: parameter.parameter_text,
//         description: parameter.description === null ? null : parameter.description || "",
//         is_active: !parameter.is_active,
//       }
//       await axios.put(url, payload)
//       Swal.fire("Success!", `The parameter has been successfully ${payload.is_active ? "activated" : "deactivated"}.`, "success")
//       await initializeAndRefreshData()
//     } catch (error) {
//       console.error("Error toggling parameter status:", error.response)
//       const errorMessage =
//         error.response?.data?.detail || JSON.stringify(error.response?.data) || "Failed to update parameter status."
//       Swal.fire("Error!", `Operation failed: ${errorMessage}`, "error")
//     } finally {
//       setIsLoading(false)
//     }
//   }

//   const handleDeleteEvaluation = async (evaluation, type, jobId) => {
//     if (type !== "general") {
//       Swal.fire("Action Not Allowed", "Parameters can only be activated or deactivated, not deleted here.", "info")
//       return
//     }
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert the deletion of this general question!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     })
//     if (result.isConfirmed) {
//       setIsLoading(true)
//       try {
//         const url = `https://raasbackend.vetrinahealthcare.com/jobs/${jobId}/evaluation-questions/${evaluation.id}/`
//         await axios.delete(url)
//         Swal.fire("Deleted!", "The general question has been deleted.", "success")
//         await initializeAndRefreshData()
//       } catch (error) {
//         console.error("Error deleting evaluation question:", error)
//         const errorDetail = error.response?.data?.detail || JSON.stringify(error.response?.data) || ""
//         if (errorDetail.includes("ProtectedError") || errorDetail.includes("protected foreign keys")) {
//           Swal.fire({
//             icon: "error",
//             title: "Deletion Failed",
//             text: "This item cannot be deleted because it is currently in use by other records (e.g., an interview evaluation).",
//           })
//         } else {
//           Swal.fire("Error!", "An unknown error occurred while trying to delete.", "error")
//         }
//       } finally {
//         setIsLoading(false)
//       }
//     }
//   }

//   const handleEditFormChange = (field, value, index = null) => {
//     if (field === "answers" && index !== null) {
//       const newAnswers = [...editEvalForm.answers]
//       newAnswers[index] = value
//       setEditEvalForm((prev) => ({ ...prev, answers: newAnswers }))
//     } else {
//       setEditEvalForm((prev) => ({ ...prev, [field]: value }))
//     }
//   }

//   const resetFormForMode = (mode) => {
//     setQuestion("")
//     setArea(PREDEFINED_AREAS[0].value)
//     setDescription("")
//     if (mode === "interviewAreaEvaluation") {
//       setQuestionType("")
//       setAnswers([])
//       setCorrect(null)
//       return
//     }
//     const defaultType = mode === "candidateQuiz" ? "mcq" : "rating"
//     setQuestionType(defaultType)
//     if (defaultType === "mcq") {
//       setAnswers(["", "", "", ""])
//       setCorrect(0)
//     } else if (defaultType === "truefalse") {
//       setAnswers(["True", "False"])
//       setTrueOrFalse("true")
//       setCorrect(0)
//     } else if (defaultType === "rating") {
//       setAnswers([...PREDEFINED_RATING_SCALE])
//       setCorrect(null)
//     } else {
//       setAnswers([""])
//       setCorrect(null)
//     }
//   }

//   const handleModeToggle = (newMode) => {
//     if (designMode === newMode) return
//     if (questions.length > 0) {
//       Swal.fire({
//         title: "Switch Design Mode?",
//         text: "You have unsaved changes. Switching modes will clear the current list. Are you sure?",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes, switch!",
//       }).then((result) => {
//         if (result.isConfirmed) {
//           setDesignMode(newMode)
//           setQuestions([])
//           resetFormForMode(newMode)
//         }
//       })
//     } else {
//       setDesignMode(newMode)
//       setQuestions([])
//       resetFormForMode(newMode)
//     }
//   }

//   const handleJobRoleChange = (e) => {
//     const selectedValue = e.target.value
//     setJobRole(selectedValue)

//     if (selectedValue) {
//       const selectedRole = jobRoles.find((role) => role.value === selectedValue)
//       if (selectedRole) {
//         setSelectedPostingType(selectedRole.type)
//         setSelectedPostingId(selectedRole.value)
//       }
//     } else {
//       // Clear if the user deselects
//       setSelectedPostingType("")
//       setSelectedPostingId("")
//     }
//   }
//   const handleQuestionChange = (e) => setQuestion(e.target.value)
//   const handleAreaChange = (e) => setArea(e.target.value)
//   const handleDescriptionChange = (e) => setDescription(e.target.value)
//   const handleQuestionTypeChange = (e) => {
//     const newType = e.target.value
//     setQuestionType(newType)
//     if (newType === "mcq") {
//       setAnswers(["", "", "", ""])
//       setCorrect(designMode === "candidateQuiz" ? 0 : null)
//     } else if (newType === "truefalse") {
//       setAnswers(["True", "False"])
//       setTrueOrFalse("true")
//       setCorrect(0)
//     } else if (newType === "rating") {
//       setAnswers([...PREDEFINED_RATING_SCALE])
//       setCorrect(null)
//     } else {
//       setAnswers([""])
//       setCorrect(null)
//     }
//   }

//   const handleAnswerChange = (index, e) => {
//     const newAnswers = [...answers]
//     newAnswers[index] = e.target.value
//     setAnswers(newAnswers)
//   }

//   const handleCorrectChange = (e) => setCorrect(Number.parseInt(e.target.value))
//   const handleTrueOrFalseChange = (e) => {
//     setTrueOrFalse(e.target.value)
//     setCorrect(e.target.value === "true" ? 0 : 1)
//   }
  
//   const itemLabel =
//     designMode === "candidateQuiz" ? "Question" : designMode === "interviewAreaEvaluation" ? "Parameter" : "Criterion"


//   const validateItem = () => {
//     if (designMode === "interviewAreaEvaluation") {
//       if (!area.trim() || !question.trim()) {
//         Swal.fire("Incomplete Fields", `Please fill in both Area and ${itemLabel} Text.`, "warning")
//         return false
//       }
//     } else {
//       if (!question.trim()) {
//         Swal.fire("Incomplete Fields", `Please enter ${itemLabel} text.`, "warning")
//         return false
//       }
//       if (questionType === "mcq" && answers.some((answer) => !answer.trim())) {
//         Swal.fire("Incomplete Fields", "Please fill in all answer options for the MCQ.", "warning")
//         return false
//       }
//     }
//     return true
//   }

//   const addItemToList = () => {
//     if (!validateItem()) return
//     let newItem
//     if (designMode === "interviewAreaEvaluation") {
//       newItem = {
//         id: Date.now(),
//         area: area,
//         question: question,
//         description: description,
//       }
//     } else {
//       newItem = {
//         id: Date.now(),
//         question: question,
//         questionType: questionType,
//       }
//       if (questionType === "mcq") {
//         newItem.answers = [...answers]
//         newItem.correct = designMode === "candidateQuiz" ? correct : null
//       } else if (questionType === "truefalse") {
//         newItem.answers = ["True", "False"]
//         newItem.correct = trueOrFalse === "true" ? 0 : 1
//       } else if (questionType === "descriptive") {
//         newItem.answers = [""]
//         newItem.correct = null
//       } else if (questionType === "rating") {
//         newItem.answers = [...PREDEFINED_RATING_SCALE]
//         newItem.correct = null
//       }
//     }
//     setQuestions([...questions, newItem])
//     resetFormForMode(designMode)
//     Swal.fire({
//       icon: "success",
//       title: "Added!",
//       text: `${itemLabel} added to the list.`,
//       toast: true,
//       position: "top-end",
//       showConfirmButton: false,
//       timer: 1500,
//     })
//   }

//   const removeItem = (index) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, remove it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         setQuestions(questions.filter((_, i) => i !== index))
//         Swal.fire("Removed!", "The item has been removed from the list.", "success")
//       }
//     })
//   }

//   const submitItems = async () => {
//     if (!jobRole) {
//         Swal.fire("Select Posting", "Please select a job, business, or consultant role.", "warning");
//         return;
//     }
//     if (questions.length === 0) {
//         Swal.fire("No Items", `Please add at least one ${itemLabel.toLowerCase()}.`, "warning");
//         return;
//     }
//     setIsLoading(true);

//     const selectedRole = jobRoles.find(role => role.value === jobRole);
//     if (!selectedRole) {
//         Swal.fire("Error", "Could not find details for the selected role. Please refresh.", "error");
//         setIsLoading(false);
//         return;
//     }

//     try {
//         if (designMode === "candidateQuiz") {
//             const postingType = selectedRole.type;
//             const postingId = selectedRole.value;
//             const apiUrl = `https://raasbackend.vetrinahealthcare.com/create_questions/${postingType}/${postingId}/`;
//             for (const q of questions) {
//                 let apiQuestionType = "";
//                 if (q.questionType === "mcq") apiQuestionType = "MCQ";
//                 else if (q.questionType === "truefalse") apiQuestionType = "TF";
//                 if (!apiQuestionType) continue;

//                 const payload = {
//                     question_text: q.question,
//                     question_type: apiQuestionType,
//                     answers: q.answers,
//                     correct_answer_index: q.correct,
//                     posting_type: postingType,
//                     posting_id: postingId,
//                 };
//                 await axios.post(apiUrl, payload);
//             }
//         } else if (designMode === "interviewerEvaluation") {
//             // New logic for Interviewer Evaluation
//             const apiUrl = 'https://raasbackend.vetrinahealthcare.com/save_evaluation/';
            
//             const evaluationDetails = questions.map(q => ({
//                 question_text: q.question,
//                 // Since this is a designer, there is no actual answer. Sending null as a placeholder.
//                 // The numeric conversion for rating scales would happen in the actual evaluation form.
//                 answer_value: null 
//             }));

//             const payload = {
//                 // The API requires candidate/interviewer details which are not available in the designer.
//                 // Sending dummy data as per the payload structure.
//                 candidate_name: "N/A - Template",
//                 candidate_email: "template@example.com",
//                 interviewer_email: "designer@example.com",
//                 job_type: selectedRole.type,
//                 job_posting_id: selectedRole.value,
//                 evaluation_details: evaluationDetails
//             };

//             await axios.post(apiUrl, payload);

//         } else if (designMode === "interviewAreaEvaluation") {
//             // Logic for Interview Parameter
//             const apiUrl = `https://raasbackend.vetrinahealthcare.com/job-postings/evaluation-parameters/`;
//             for (const param of questions) {
//                 const payload = {
//                     posting_type: selectedRole.type,
//                     posting_id: selectedRole.value,
//                     area: param.area,
//                     parameter_text: param.question,
//                     description: param.description,
//                 };
//                 await axios.post(apiUrl, payload);
//             }
//         }

//         Swal.fire("Success!", `${itemLabel}s submitted successfully.`, "success");
//         setQuestions([]);
//         await initializeAndRefreshData();
//     } catch (error) {
//         console.error("Error submitting items:", error);
//         const errorMessage =
//             error.response?.data?.detail ||
//             error.response?.data?.error ||
//             JSON.stringify(error.response?.data) ||
//             "An unknown error occurred.";
//         Swal.fire(
//             "Submission Error!",
//             `Failed to submit. Server says: ${errorMessage}`,
//             "error"
//         );
//     } finally {
//         setIsLoading(false);
//     }
// };


//   const handleEdit = (index) => {
//     const itemToEdit = questions[index]
//     setEditingIndex(index)
//     setEditedQuestion(itemToEdit.question)
//     if (designMode === "interviewAreaEvaluation") {
//       setEditedArea(itemToEdit.area || PREDEFINED_AREAS[0].value)
//       setEditedDescription(itemToEdit.description || "")
//     } else {
//       setEditedQuestionType(itemToEdit.questionType)
//       if (itemToEdit.questionType === "mcq") {
//         setEditedAnswers([...itemToEdit.answers])
//         setEditedCorrect(designMode === "candidateQuiz" ? itemToEdit.correct : null)
//       } else if (itemToEdit.questionType === "truefalse") {
//         setEditedTrueOrFalse(itemToEdit.correct === 0 ? "true" : "false")
//         setEditedCorrect(itemToEdit.correct)
//       }
//     }
//   }

//   const handleSave = (index) => {
//     let updatedItem
//     if (designMode === "interviewAreaEvaluation") {
//       if (!editedArea.trim() || !editedQuestion.trim()) {
//         Swal.fire("Validation Error", `Area and ${itemLabel} Text cannot be empty.`, "warning")
//         return
//       }
//       updatedItem = {
//         ...questions[index],
//         area: editedArea,
//         question: editedQuestion,
//         description: editedDescription,
//       }
//     } else {
//       if (!editedQuestion.trim()) {
//         Swal.fire("Validation Error", "Text cannot be empty.", "warning")
//         return
//       }
//       if (editedQuestionType === "mcq" && editedAnswers.some((ans) => !ans.trim())) {
//         Swal.fire("Validation Error", "All MCQ options must be filled.", "warning")
//         return
//       }
//       updatedItem = {
//         ...questions[index],
//         question: editedQuestion,
//         questionType: editedQuestionType,
//       }
//       if (editedQuestionType === "mcq") {
//         updatedItem.answers = [...editedAnswers]
//         updatedItem.correct = designMode === "candidateQuiz" ? editedCorrect : null
//       } else if (editedQuestionType === "truefalse") {
//         updatedItem.answers = ["True", "False"]
//         updatedItem.correct = editedTrueOrFalse === "true" ? 0 : 1
//       } else {
//         updatedItem.answers = editedQuestionType === "rating" ? [...PREDEFINED_RATING_SCALE] : [""]
//         updatedItem.correct = null
//       }
//     }
//     const newQuestions = [...questions]
//     newQuestions[index] = updatedItem
//     setQuestions(newQuestions)
//     setEditingIndex(null)
//     Swal.fire({
//       icon: "success",
//       title: "Saved!",
//       text: "Changes have been updated.",
//       timer: 1000,
//       toast: true,
//       position: "top-end",
//       showConfirmButton: false,
//     })
//   }

//   const handleCancelEdit = () => setEditingIndex(null)
//   const handleEditedQuestionChange = (e) => setEditedQuestion(e.target.value)
//   const handleEditedAreaChange = (e) => setEditedArea(e.target.value)
//   const handleEditedDescriptionChange = (e) => setEditedDescription(e.target.value)
//   const handleEditedQuestionTypeChange = (e) => {
//     const newType = e.target.value
//     setEditedQuestionType(newType)
//     if (newType === "mcq") {
//       setEditedAnswers(
//         editedAnswers.length === 4 && editedAnswers.every((a) => typeof a === "string")
//           ? [...editedAnswers]
//           : ["", "", "", ""],
//       )
//       setEditedCorrect(designMode === "candidateQuiz" ? 0 : null)
//     } else if (newType === "truefalse") {
//       setEditedTrueOrFalse("true")
//       setEditedCorrect(0)
//     }
//   }
//   const handleEditedAnswerChange = (idx, e) => {
//     const newAns = [...editedAnswers]
//     newAns[idx] = e.target.value
//     setEditedAnswers(newAns)
//   }
//   const handleEditedCorrectChange = (e) => setEditedCorrect(Number.parseInt(e.target.value))
//   const handleEditedTrueOrFalseChange = (e) => {
//     setEditedTrueOrFalse(e.target.value)
//     setEditedCorrect(e.target.value === "true" ? 0 : 1)
//   }

//   const handleJobCardClick = (jobData) => {
//     setSelectedJobEvaluations(jobData)
//     setShowEvaluationDetails(true)
//   }

//   const pageTitle =
//     designMode === "candidateQuiz"
//       ? "Candidate Quiz Designer"
//       : designMode === "interviewerEvaluation"
//       ? "Interviewer Evaluation Form Designer"
//       : "Interview Parameter Designer"

//   const renderAnswerInputs = () => {
//     switch (questionType) {
//       case "mcq":
//         return (
//           <div className="mcq-options">
//             <div className="row">
//               <div className="col-md-6">
//                 <div className="mb-2">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={answers[0]}
//                     onChange={(e) => handleAnswerChange(0, e)}
//                     placeholder="Option 1"
//                   />
//                 </div>
//                 <div className="mb-2">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={answers[1]}
//                     onChange={(e) => handleAnswerChange(1, e)}
//                     placeholder="Option 2"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <div className="mb-2">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={answers[2]}
//                     onChange={(e) => handleAnswerChange(2, e)}
//                     placeholder="Option 3"
//                   />
//                 </div>
//                 <div className="mb-2">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={answers[3]}
//                     onChange={(e) => handleAnswerChange(3, e)}
//                     placeholder="Option 4"
//                   />
//                 </div>
//               </div>
//             </div>
//             {designMode === "candidateQuiz" && (
//               <div className="row">
//                 <div className="col-12">
//                   <label htmlFor="correct" className="form-label form-label-sm">
//                     Correct Option:
//                   </label>
//                   <select
//                     id="correct"
//                     className="form-select form-select-sm"
//                     value={correct === null ? "" : correct}
//                     onChange={handleCorrectChange}
//                   >
//                     {answers.map((_, i) => (
//                       <option key={i} value={i}>
//                         Option {i + 1}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             )}
//           </div>
//         )
//       case "truefalse":
//         return (
//           <div className="true-false-options">
//             <label className="form-label form-label-sm">Correct Answer:</label>
//             <div className="d-flex align-items-center">
//               <div className="form-check form-check-inline mb-0">
//                 <input
//                   className="form-check-input"
//                   type="radio"
//                   name="truefalse"
//                   id="true"
//                   value="true"
//                   checked={trueOrFalse === "true"}
//                   onChange={handleTrueOrFalseChange}
//                 />
//                 <label className="form-check-label" htmlFor="true">
//                   True
//                 </label>
//               </div>
//               <div className="form-check form-check-inline mb-0">
//                 <input
//                   className="form-check-input"
//                   type="radio"
//                   name="truefalse"
//                   id="false"
//                   value="false"
//                   checked={trueOrFalse === "false"}
//                   onChange={handleTrueOrFalseChange}
//                 />
//                 <label className="form-check-label" htmlFor="false">
//                   False
//                 </label>
//               </div>
//             </div>
//           </div>
//         )
//       case "descriptive":
//         return <p className="text-muted small fst-italic mb-0">Candidate will provide a text-based response.</p>
//       case "rating":
//         return (
//           <div className="rating-options">
//             <p className="small text-muted mb-1">This criterion will use the standard rating scale:</p>
//             <div className="d-flex flex-wrap gap-1">
//               {PREDEFINED_RATING_SCALE.map((item) => (
//                 <span key={item} className="badge bg-light text-dark border me-1">
//                   {item}
//                 </span>
//               ))}
//             </div>
//           </div>
//         )
//       default:
//         return null
//     }
//   }

//   const renderEditAnswerInputs = () => {
//     switch (editedQuestionType) {
//       case "mcq":
//         return (
//           <>
//             {editedAnswers.map((ans, idx) => (
//               <div key={`edit-mcq-${idx}`} className="mb-1">
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   value={ans}
//                   onChange={(e) => handleEditedAnswerChange(idx, e)}
//                   placeholder={`Opt ${idx + 1}`}
//                 />
//               </div>
//             ))}
//             {designMode === "candidateQuiz" && (
//               <div className="mt-1 mb-0">
//                 <label htmlFor="edit-correct" className="form-label form-label-sm visually-hidden">
//                   Correct:
//                 </label>
//                 <select
//                   id="edit-correct"
//                   className="form-select form-select-sm"
//                   value={editedCorrect === null ? "" : editedCorrect}
//                   onChange={handleEditedCorrectChange}
//                 >
//                   {editedAnswers.map((_, i) => (
//                     <option key={i} value={i}>
//                       Opt {i + 1}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//           </>
//         )
//       case "truefalse":
//         return (
//           <div className="d-flex align-items-center mt-1">
//             <span className="me-2 small text-muted">Correct:</span>
//             <div className="form-check form-check-inline mb-0">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="edit-truefalse"
//                 id="edit-true"
//                 value="true"
//                 checked={editedTrueOrFalse === "true"}
//                 onChange={handleEditedTrueOrFalseChange}
//               />
//               <label className="form-check-label small" htmlFor="edit-true">
//                 T
//               </label>
//             </div>
//             <div className="form-check form-check-inline mb-0">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="edit-truefalse"
//                 id="edit-false"
//                 value="false"
//                 checked={editedTrueOrFalse === "false"}
//                 onChange={handleEditedTrueOrFalseChange}
//               />
//               <label className="form-check-label small" htmlFor="edit-false">
//                 F
//               </label>
//             </div>
//           </div>
//         )
//       case "descriptive":
//         return <p className="text-muted fst-italic small my-1">Text response.</p>
//       case "rating":
//         return <p className="text-muted fst-italic small my-1">Uses standard rating scale.</p>
//       default:
//         return null
//     }
//   }

//   const renderAnswerDisplay = (q) => {
//     if (q.questionType === "mcq") {
//       return (
//         <ol type="A" className="mb-0 ps-3 small">
//           {q.answers.map((ans, i) => (
//             <li
//               key={i}
//               className={
//                 designMode === "candidateQuiz" && q.correct !== null && q.correct === i ? "fw-bold text-success" : ""
//               }
//             >
//               {ans}
//               {designMode === "candidateQuiz" && q.correct !== null && q.correct === i && " ✔"}
//             </li>
//           ))}
//         </ol>
//       )
//     } else if (q.questionType === "truefalse") {
//       return (
//         <p className="mb-0 small">
//           Correct: <span className="fw-bold text-success">{q.answers[q.correct]}</span>
//         </p>
//       )
//     } else if (q.questionType === "descriptive") {
//       return <p className="text-muted fst-italic mb-0 small">Descriptive (text)</p>
//     } else if (q.questionType === "rating") {
//       return <p className="text-muted fst-italic mb-0 small">Rating Scale</p>
//     }
//     return null
//   }

//   return (
//     <div>
//       <DashNavbar />
//       <div className="wrapper">
//         <Sidebar />
//         <div className="main">
//           <div className="container-fluid py-3" style={{ height: "calc(100vh - 56px)" }}>
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <h2 className="mb-0">{pageTitle}</h2>
//               <button className="btn btn-outline-secondary" onClick={() => navigate("/Admindashboard")}>
//                 <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
//                 Back to Dashboard
//               </button>
//             </div>

//             <div className="mb-3 p-2 border rounded bg-light">
//               <div className="row align-items-center">
//                 <div className="col-md-3">
//                   <label className="form-label fw-bold mb-0">Design Mode:</label>
//                 </div>
//                 <div className="col-md-9">
//                   <div className="btn-group w-100" role="group">
//                     <button
//                       type="button"
//                       className={`btn btn-sm ${designMode === "candidateQuiz" ? "btn-primary" : "btn-outline-primary"}`}
//                       onClick={() => handleModeToggle("candidateQuiz")}
//                     >
//                       <FontAwesomeIcon icon={faQuestionCircle} className="me-1" />
//                       Candidate Quiz
//                     </button>
//                     <button
//                       type="button"
//                       className={`btn btn-sm ${designMode === "interviewerEvaluation" ? "btn-primary" : "btn-outline-primary"}`}
//                       onClick={() => handleModeToggle("interviewerEvaluation")}
//                     >
//                       <FontAwesomeIcon icon={faClipboardList} className="me-1" />
//                       Interviewer Questions
//                     </button>
//                     <button
//                       type="button"
//                       className={`btn btn-sm ${designMode === "interviewAreaEvaluation" ? "btn-primary" : "btn-outline-primary"}`}
//                       onClick={() => handleModeToggle("interviewAreaEvaluation")}
//                     >
//                       <FontAwesomeIcon icon={faTasks} className="me-1" />
//                       Post Interview Evaluation
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="row h-100" style={{ maxHeight: "calc(100vh - 170px)" }}>
//               {/* Left Side - Form and Questions List */}
//               <div className="col-lg-8 mb-3 d-flex flex-column h-100">
//                 <div className="row h-100">
//                   {/* ADD NEW ITEM FORM */}
//                   <div className="col-lg-6 mb-3 d-flex flex-column h-100">
//                     <div className="card shadow-sm d-flex flex-column flex-grow-1">
//                       <div className="card-header bg-white py-2">
//                         <h5 className="mb-0">Add New {itemLabel}</h5>
//                       </div>
//                       <div className="card-body p-3 flex-grow-1 d-flex flex-column">
//                         <div className="row g-2">
//                           <div className={designMode === "interviewAreaEvaluation" ? "col-12" : "col-md-6"}>
//                             <label htmlFor="jobRole" className="form-label form-label-sm">
//                               Role <span className="text-danger">*</span>
//                             </label>
//                             <select
//                               id="jobRole"
//                               className="form-select form-select-sm"
//                               value={jobRole}
//                               onChange={handleJobRoleChange}
//                               required
//                             >
//                               <option value="">-- Select Job Role --</option>
//                               {jobRoles.map((role) => (
//                                 <option key={role.value} value={role.value}>
//                                   {role.label}
//                                 </option>
//                               ))}
//                             </select>
//                           </div>
//                           {designMode !== "interviewAreaEvaluation" && (
//                             <div className="col-md-6">
//                               <label htmlFor="questionType" className="form-label form-label-sm">
//                                 Type <span className="text-danger">*</span>
//                               </label>
//                               <select
//                                 id="questionType"
//                                 className="form-select form-select-sm"
//                                 value={questionType}
//                                 onChange={handleQuestionTypeChange}
//                                 required
//                               >
//                                 <option value="mcq">Multiple Choice</option>
//                                 <option value="truefalse">True/False</option>
//                                 <option value="descriptive">Descriptive Answer</option>
//                                 {designMode === "interviewerEvaluation" && <option value="rating">Rating Scale</option>}
//                               </select>
//                             </div>
//                           )}
//                         </div>

//                         {/* Display for Posting Type and ID */}
//                         {jobRole && (
//                           <div className="row g-2 mt-2">
//                             <div className="col-6">
//                               <label className="form-label form-label-sm text-muted mb-0">Posting Type</label>
//                               <p className="form-control-plaintext form-control-sm ps-2 py-1 bg-light rounded border mb-0">
//                                 {selectedPostingType.replace(/_/g, " ")}
//                               </p>
//                             </div>
//                             <div className="col-6">
//                               <label className="form-label form-label-sm text-muted mb-0">Posting ID</label>
//                               <p className="form-control-plaintext form-control-sm ps-2 py-1 bg-light rounded border mb-0">
//                                 {selectedPostingId}
//                               </p>
//                             </div>
//                           </div>
//                         )}

//                         {designMode === "interviewAreaEvaluation" && (
//                           <div className="mt-2">
//                             <label htmlFor="area" className="form-label form-label-sm">
//                               Area <span className="text-danger">*</span>
//                             </label>
//                             <select
//                               id="area"
//                               className="form-select form-select-sm"
//                               value={area}
//                               onChange={handleAreaChange}
//                             >
//                               {PREDEFINED_AREAS.map((areaOption) => (
//                                 <option key={areaOption.value} value={areaOption.value}>
//                                   {areaOption.label}
//                                 </option>
//                               ))}
//                             </select>
//                           </div>
//                         )}
//                         <div className="mt-2">
//                           <label htmlFor="question" className="form-label form-label-sm">
//                             {itemLabel} Text <span className="text-danger">*</span>
//                           </label>
//                           <textarea
//                             id="question"
//                             className="form-control form-control-sm"
//                             rows="2"
//                             value={question}
//                             onChange={handleQuestionChange}
//                             placeholder={`Enter ${itemLabel.toLowerCase()} text here...`}
//                             required
//                           />
//                         </div>
//                         {designMode === "interviewAreaEvaluation" ? (
//                           <div className="mt-2 flex-grow-1">
//                             <label htmlFor="description" className="form-label form-label-sm">
//                               Description <span className="text-muted">(Optional)</span>
//                             </label>
//                             <textarea
//                               id="description"
//                               className="form-control form-control-sm"
//                               rows="2"
//                               value={description}
//                               onChange={handleDescriptionChange}
//                               placeholder="Provide a brief description or instruction..."
//                             />
//                           </div>
//                         ) : (
//                           <div className="mt-2 p-2 border rounded bg-light-subtle flex-grow-1">
//                             {renderAnswerInputs()}
//                           </div>
//                         )}
//                         <div className="d-grid mt-auto pt-3">
//                           <button type="button" className="btn btn-info text-white" onClick={addItemToList}>
//                             <FontAwesomeIcon icon={faPlus} className="me-2" />
//                             Add {itemLabel} to List
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* ITEM LIST */}
//                   <div className="col-lg-6 h-100">
//                     <div className="d-flex flex-column h-100">
//                       <div className="d-flex justify-content-between align-items-center mb-2">
//                         <h5 className="mb-0">
//                           {questions.length > 0 ? (
//                             <>
//                               Current List for{" "}
//                               <span className="text-primary">
//                                 {jobRoles.find((jr) => jr.value.toString() === jobRole.toString())?.label ||
//                                   "Selected Role"}
//                               </span>
//                             </>
//                           ) : (
//                             "Item List"
//                           )}
//                         </h5>
//                         {questions.length > 0 && (
//                           <span className="badge bg-primary rounded-pill">
//                             {questions.length} {questions.length === 1 ? itemLabel : `${itemLabel}s`}
//                           </span>
//                         )}
//                       </div>
//                       <div className="flex-grow-1 overflow-auto" style={{ maxHeight: "calc(100% - 80px)" }}>
//                         {questions.length > 0 ? (
//                           <div className="table-responsive shadow-sm rounded h-100">
//                             <table
//                               className="table table-hover table-bordered align-middle mb-0"
//                               style={{ fontSize: "0.9rem" }}
//                             >
//                               <thead className="table-light sticky-top" style={{ top: 0, zIndex: 1 }}>
//                                 {designMode === "interviewAreaEvaluation" ? (
//                                   <tr>
//                                     <th style={{ width: "5%" }} className="text-center">
//                                       #
//                                     </th>
//                                     <th style={{ width: "40%" }}>{itemLabel} / Area</th>
//                                     <th style={{ width: "35%" }}>Description</th>
//                                     <th style={{ width: "20%" }} className="text-center">
//                                       Actions
//                                     </th>
//                                   </tr>
//                                 ) : (
//                                   <tr>
//                                     <th style={{ width: "5%" }} className="text-center">
//                                       #
//                                     </th>
//                                     <th style={{ width: "35%" }}>{itemLabel}</th>
//                                     <th style={{ width: "15%" }} className="text-center">
//                                       Type
//                                     </th>
//                                     <th style={{ width: "25%" }}>Details/Options</th>
//                                     <th style={{ width: "20%" }} className="text-center">
//                                       Actions
//                                     </th>
//                                   </tr>
//                                 )}
//                               </thead>
//                               <tbody>
//                                 {questions.map((q, index) => (
//                                   <tr key={q.id || index}>
//                                     <td className="text-center">{index + 1}</td>
//                                     {editingIndex === index ? (
//                                       <>
//                                         {designMode === "interviewAreaEvaluation" ? (
//                                           <>
//                                             <td>
//                                               <div className="mb-1">
//                                                 <select
//                                                   className="form-select form-select-sm"
//                                                   value={editedArea}
//                                                   onChange={handleEditedAreaChange}
//                                                 >
//                                                   {PREDEFINED_AREAS.map((areaOption) => (
//                                                     <option key={areaOption.value} value={areaOption.value}>
//                                                       {areaOption.label}
//                                                     </option>
//                                                   ))}
//                                                 </select>
//                                               </div>
//                                               <textarea
//                                                 className="form-control form-control-sm"
//                                                 value={editedQuestion}
//                                                 onChange={handleEditedQuestionChange}
//                                                 rows="2"
//                                               />
//                                             </td>
//                                             <td>
//                                               <textarea
//                                                 className="form-control form-control-sm"
//                                                 value={editedDescription}
//                                                 onChange={handleEditedDescriptionChange}
//                                                 rows="3"
//                                               />
//                                             </td>
//                                           </>
//                                         ) : (
//                                           <>
//                                             <td>
//                                               <textarea
//                                                 className="form-control form-control-sm"
//                                                 value={editedQuestion}
//                                                 onChange={handleEditedQuestionChange}
//                                                 rows="3"
//                                               />
//                                             </td>
//                                             <td className="text-center">
//                                               <select
//                                                 className="form-select form-select-sm"
//                                                 value={editedQuestionType}
//                                                 onChange={handleEditedQuestionTypeChange}
//                                               >
//                                                 <option value="mcq">MCQ</option>
//                                                 <option value="truefalse">T/F</option>
//                                                 <option value="descriptive">Desc.</option>
//                                                 {designMode === "interviewerEvaluation" && (
//                                                   <option value="rating">Rating</option>
//                                                 )}
//                                               </select>
//                                             </td>
//                                             <td className="small">{renderEditAnswerInputs()}</td>
//                                           </>
//                                         )}
//                                         <td className="text-center">
//                                           <div className="btn-group btn-group-sm">
//                                             <button
//                                               className="btn btn-success"
//                                               onClick={() => handleSave(index)}
//                                               title="Save"
//                                             >
//                                               <FontAwesomeIcon icon={faCheck} />
//                                             </button>
//                                             <button
//                                               className="btn btn-secondary"
//                                               onClick={handleCancelEdit}
//                                               title="Cancel"
//                                             >
//                                               <FontAwesomeIcon icon={faTimes} />
//                                             </button>
//                                           </div>
//                                         </td>
//                                       </>
//                                     ) : (
//                                       <>
//                                         {designMode === "interviewAreaEvaluation" ? (
//                                           <>
//                                             <td>
//                                               {q.area && (
//                                                 <span className="badge bg-secondary mb-1">
//                                                   {PREDEFINED_AREAS.find((a) => a.value === q.area)?.label || q.area}
//                                                 </span>
//                                               )}
//                                               <div>{q.question}</div>
//                                             </td>
//                                             <td>
//                                               <small className="text-muted">{q.description}</small>
//                                             </td>
//                                           </>
//                                         ) : (
//                                           <>
//                                             <td>{q.question}</td>
//                                             <td className="text-center">
//                                               {q.questionType.charAt(0).toUpperCase() + q.questionType.slice(1)}
//                                             </td>
//                                             <td className="small">{renderAnswerDisplay(q)}</td>
//                                           </>
//                                         )}
//                                         <td className="text-center">
//                                           <div className="btn-group btn-group-sm">
//                                             <button
//                                               className="btn btn-outline-primary"
//                                               onClick={() => handleEdit(index)}
//                                               title="Edit"
//                                             >
//                                               <FontAwesomeIcon icon={faEdit} />
//                                             </button>
//                                             <button
//                                               className="btn btn-outline-danger"
//                                               onClick={() => removeItem(index)}
//                                               title="Remove"
//                                             >
//                                               <FontAwesomeIcon icon={faTrash} />
//                                             </button>
//                                           </div>
//                                         </td>
//                                       </>
//                                     )}
//                                   </tr>
//                                 ))}
//                               </tbody>
//                             </table>
//                           </div>
//                         ) : (
//                           <div className="card shadow-sm h-100">
//                             <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-5">
//                               <FontAwesomeIcon
//                                 icon={faInfoCircle}
//                                 className="text-muted mb-3"
//                                 style={{ fontSize: "3rem" }}
//                               />
//                               <h4>No {itemLabel.toLowerCase()}s added yet</h4>
//                               <p className="text-muted mb-0">
//                                 Use the form on the left to add items for the selected job role and design mode.
//                               </p>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                       {questions.length > 0 && (
//                         <div className="d-grid mt-3">
//                           <button
//                             type="button"
//                             className="btn btn-success"
//                             onClick={submitItems}
//                             disabled={!jobRole || isLoading}
//                           >
//                             {isLoading ? (
//                               <>
//                                 <span className="spinner-border spinner-border-sm me-2" />
//                                 Submitting...
//                               </>
//                             ) : (
//                               <>
//                                 <FontAwesomeIcon icon={faSave} className="me-2" />
//                                 Submit All for{" "}
//                                 {jobRoles.find((jr) => jr.value.toString() === jobRole.toString())?.label}
//                               </>
//                             )}
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Right Side - Evaluations */}
//               <div className="col-lg-4 h-100">
//                 <div className="card shadow-sm h-100">
//                   <div className="card-header bg-primary text-white py-2 d-flex justify-content-between align-items-center">
//                     <h5 className="mb-0">
//                       <FontAwesomeIcon icon={faClipboardList} className="me-2" />
//                       Evaluation Setups
//                     </h5>
//                     <button
//                       className="btn btn-sm btn-outline-light"
//                       onClick={initializeAndRefreshData}
//                       disabled={evaluationsLoading}
//                     >
//                       {evaluationsLoading ? <span className="spinner-border spinner-border-sm" /> : "Refresh"}
//                     </button>
//                   </div>
//                   <div className="card-body p-0 overflow-auto">
//                     {evaluationsLoading ? (
//                       <div className="d-flex justify-content-center align-items-center p-5">
//                         <div className="spinner-border text-primary" role="status">
//                           <span className="visually-hidden">Loading...</span>
//                         </div>
//                       </div>
//                     ) : Object.keys(jobEvaluationSummary).length > 0 ? (
//                       <div className="p-3">
//                         {Object.values(jobEvaluationSummary).map((jobData) => (
//                           <div
//                             key={jobData.job_id}
//                             className="card mb-3 border-0 shadow-sm hover-card"
//                             style={{ cursor: "pointer" }}
//                             onClick={() => handleJobCardClick(jobData)}
//                           >
//                             <div className="card-body p-3">
//                               <div className="d-flex justify-content-between align-items-start mb-2">
//                                 <h6 className="card-title mb-1 text-primary">
//                                   <FontAwesomeIcon icon={faBuilding} className="me-2" />
//                                   {jobData.job_title}
//                                 </h6>
//                               </div>
//                               <p className="card-text small text-muted mb-2">ID: {jobData.job_id}</p>
//                               <div className="row text-center">
//                                 <div className="col-6">
//                                   <small className="text-muted d-block">General Q's</small>
//                                   <span className="badge bg-info">{jobData.general_question_count}</span>
//                                 </div>
//                                 <div className="col-6">
//                                   <small className="text-muted d-block">Parameters</small>
//                                   <span className="badge bg-success">{jobData.parameter_count}</span>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     ) : (
//                       <div className="d-flex flex-column justify-content-center align-items-center p-5 text-center">
//                         <FontAwesomeIcon icon={faInfoCircle} className="text-muted mb-3" style={{ fontSize: "3rem" }} />
//                         <h5>No Evaluation Setups Found</h5>
//                         <p className="text-muted mb-0">Use the designer on the left to add questions or parameters.</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Evaluation Details Modal */}
//             {showEvaluationDetails && selectedJobEvaluations && (
//               <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
//                 <div className="modal-dialog modal-xl modal-dialog-scrollable">
//                   <div className="modal-content">
//                     <div className="modal-header bg-primary text-white">
//                       <h5 className="modal-title">
//                         <FontAwesomeIcon icon={faEye} className="me-2" />
//                         Evaluations for {selectedJobEvaluations.job_title}
//                       </h5>
//                       <button
//                         type="button"
//                         className="btn-close btn-close-white"
//                         onClick={() => setShowEvaluationDetails(false)}
//                       ></button>
//                     </div>
//                     <div className="modal-body p-0">
//                       <div className="row g-0">
//                         {/* General Evaluations */}
//                         <div className="col-md-6 border-end">
//                           <div className="p-3 bg-info text-white">
//                             <h6 className="mb-0">
//                               <FontAwesomeIcon icon={faClipboardList} className="me-2" />
//                               General Evaluation Questions (
//                               {evaluationQuestions[selectedJobEvaluations.job_id]?.length || 0})
//                             </h6>
//                           </div>
//                           <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto" }}>
//                             {evaluationQuestions[selectedJobEvaluations.job_id]?.length > 0 ? (
//                               evaluationQuestions[selectedJobEvaluations.job_id].map((question) => (
//                                 <div key={question.id} className="card mb-3 border-0 shadow-sm">
//                                   <div className="card-body p-3">
//                                     <div>
//                                       <div className="d-flex justify-content-between align-items-start mb-2">
//                                         <h6 className="card-title mb-1">
//                                           <FontAwesomeIcon icon={faQuestionCircle} className="me-2 text-info" />
//                                           Question #{question.id}
//                                         </h6>
//                                         <div className="btn-group btn-group-sm">
//                                           <button
//                                             className="btn btn-outline-danger btn-sm"
//                                             onClick={() =>
//                                               handleDeleteEvaluation(
//                                                 question,
//                                                 "general",
//                                                 selectedJobEvaluations.job_id,
//                                               )
//                                             }
//                                             title="Delete General Question"
//                                           >
//                                             <FontAwesomeIcon icon={faTrash} />
//                                           </button>
//                                         </div>
//                                       </div>
//                                       <p className="mb-2 text-justify">
//                                         <strong>Question:</strong> {question.question_text}
//                                       </p>
//                                     </div>
//                                   </div>
//                                 </div>
//                               ))
//                             ) : (
//                               <div className="text-center p-4">
//                                 <FontAwesomeIcon
//                                   icon={faInfoCircle}
//                                   className="text-muted mb-2"
//                                   style={{ fontSize: "2rem" }}
//                                 />
//                                 <p className="text-muted">No general evaluation questions found.</p>
//                               </div>
//                             )}
//                           </div>
//                         </div>

//                         {/* Parameter Evaluations */}
//                         <div className="col-md-6">
//                           <div className="p-3 bg-success text-white">
//                             <h6 className="mb-0">
//                               <FontAwesomeIcon icon={faTasks} className="me-2" />
//                               Evaluation Parameters ({evaluationParameters[selectedJobEvaluations.job_id]?.length || 0})
//                             </h6>
//                           </div>
//                           <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto" }}>
//                             {evaluationParameters[selectedJobEvaluations.job_id]?.length > 0 ? (
//                               evaluationParameters[selectedJobEvaluations.job_id].map((parameter) => (
//                                 <div key={parameter.id} className="card mb-3 border-0 shadow-sm">
//                                   <div className="card-body p-3">
//                                     {editingEvaluation?.id === parameter.id && editingEvaluationType === "parameter" ? (
//                                       // Edit form for parameter evaluation (This part is not shown but functionality exists)
//                                       <div>
//                                         {/* ... Edit Form would go here if clicked ... */}
//                                       </div>
//                                     ) : (
//                                       // Display mode for parameter evaluation
//                                       <div>
//                                         <div className="d-flex justify-content-between align-items-start mb-2">
//                                           <h6 className="card-title mb-1">
//                                             <FontAwesomeIcon icon={faTasks} className="me-2 text-success" />
//                                             Parameter #{parameter.id}
//                                           </h6>
//                                           <div className="btn-group btn-group-sm">
//                                             <button
//                                               className="btn btn-outline-primary btn-sm"
//                                               onClick={() => handleEditEvaluation(parameter, "parameter")}
//                                               title="Edit"
//                                             >
//                                               <FontAwesomeIcon icon={faEdit} />
//                                             </button>
//                                             <button
//                                               className={`btn btn-sm ${
//                                                 parameter.is_active ? "btn-outline-warning" : "btn-outline-success"
//                                               }`}
//                                               onClick={() =>
//                                                 handleToggleParameterActiveStatus(
//                                                   parameter,
//                                                   selectedJobEvaluations.job_id,
//                                                 )
//                                               }
//                                               title={parameter.is_active ? "Deactivate" : "Activate"}
//                                             >
//                                               <FontAwesomeIcon icon={parameter.is_active ? faBan : faCheck} />
//                                             </button>
//                                           </div>
//                                         </div>
//                                         <p className="mb-1">
//                                           <strong>Area:</strong>{" "}
//                                           <span className="badge bg-light text-dark">
//                                             {PREDEFINED_AREAS.find((a) => a.value === parameter.area)?.label ||
//                                               parameter.area}
//                                           </span>
//                                         </p>
//                                         <p className="mb-1 text-justify">
//                                           <strong>Parameter:</strong> {parameter.parameter_text}
//                                         </p>
//                                         {parameter.description && (
//                                           <p className="mb-1 text-justify small text-muted">
//                                             <strong>Desc:</strong> {parameter.description}
//                                           </p>
//                                         )}
//                                         <p className="mb-0">
//                                           <strong>Status:</strong>{" "}
//                                           <span
//                                             className={`badge ${parameter.is_active ? "bg-success" : "bg-secondary"}`}
//                                           >
//                                             {parameter.is_active ? "Active" : "Inactive"}
//                                           </span>
//                                         </p>
//                                       </div>
//                                     )}
//                                   </div>
//                                 </div>
//                               ))
//                             ) : (
//                               <div className="text-center p-4">
//                                 <FontAwesomeIcon
//                                   icon={faInfoCircle}
//                                   className="text-muted mb-2"
//                                   style={{ fontSize: "2rem" }}
//                                 />
//                                 <p className="text-muted">No evaluation parameters found.</p>
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="modal-footer">
//                       <button
//                         type="button"
//                         className="btn btn-secondary"
//                         onClick={() => {
//                           setShowEvaluationDetails(false)
//                           setEditingEvaluation(null)
//                           setEditingEvaluationType(null)
//                         }}
//                       >
//                         Close
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .hover-card:hover {
//           transform: translateY(-2px);
//           transition: transform 0.2s ease-in-out;
//         }
//         .modal.show {
//           display: block !important;
//         }
//         .text-justify {
//           text-align: justify;
//         }
//       `}</style>
//     </div>
//   )
// }

// export default CreateQuestions
"use client"
import { useState, useEffect } from "react"
import axios from "axios"
import Swal from "sweetalert2"
import DashNavbar from "./DashNavbar"
import Sidebar from "./Sidebar"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTrash,
  faPlus,
  faEdit,
  faCheck,
  faTimes,
  faQuestionCircle,
  faClipboardList,
  faArrowLeft,
  faSave,
  faInfoCircle,
  faTasks,
  faEye,
  faBuilding,
  faBan, // For deactivation
  faRefresh
} from "@fortawesome/free-solid-svg-icons"

const PREDEFINED_RATING_SCALE = ["Exceptional", "Above Average", "Average", "Satisfactory", "Unsatisfactory"]
const PREDEFINED_AREAS = [
  { value: "CORE_COMPETENCIES", label: "1. Core Competencies" },
  { value: "BEHAVIORAL", label: "2. Additional Behavioral & Functional Parameters" },
  { value: "ROLE_FIT", label: "3. Role-Specific & Cultural Fit" },
]

function CreateQuestions() {
  const [designMode, setDesignMode] = useState("candidateQuiz")
  const [jobRole, setJobRole] = useState("")
  // New state to display posting details
  const [selectedPostingType, setSelectedPostingType] = useState("")
  const [selectedPostingId, setSelectedPostingId] = useState("")
  const [question, setQuestion] = useState("")
  const [area, setArea] = useState(PREDEFINED_AREAS[0].value)
  const [description, setDescription] = useState("")
  const [questionType, setQuestionType] = useState("mcq")
  const [answers, setAnswers] = useState(["", "", "", ""])
  const [correct, setCorrect] = useState(0)
  const [trueOrFalse, setTrueOrFalse] = useState("true")
  const [questions, setQuestions] = useState([])
  const [jobRoles, setJobRoles] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [editingIndex, setEditingIndex] = useState(null)
  const [editedQuestion, setEditedQuestion] = useState("")
  const [editedArea, setEditedArea] = useState(PREDEFINED_AREAS[0].value)
  const [editedDescription, setEditedDescription] = useState("")
  const [editedQuestionType, setEditedQuestionType] = useState("mcq")
  const [editedAnswers, setEditedAnswers] = useState(["", "", "", ""])
  const [editedCorrect, setEditedCorrect] = useState(0)
  const [editedTrueOrFalse, setEditedTrueOrFalse] = useState("true")

  // State for evaluation setups
  const [jobEvaluationSummary, setJobEvaluationSummary] = useState({})
  const [selectedJobEvaluations, setSelectedJobEvaluations] = useState(null)
  const [showEvaluationDetails, setShowEvaluationDetails] = useState(false)
  const [evaluationsLoading, setEvaluationsLoading] = useState(false)

  // State for evaluation questions and parameters (for CRUD operations)
  const [evaluationQuestions, setEvaluationQuestions] = useState({})
  const [evaluationParameters, setEvaluationParameters] = useState({})

  // Edit states for evaluations
  const [editingEvaluation, setEditingEvaluation] = useState(null)
  const [editingEvaluationType, setEditingEvaluationType] = useState(null) // 'general' or 'parameter'
  const [editEvalForm, setEditEvalForm] = useState({
    question_text: "",
    answers: ["", "", "", ""],
    correct_answer_index: 0,
    area: "CORE_COMPETENCIES",
    parameter_text: "",
    description: "",
    is_active: true,
  })

  const navigate = useNavigate()

  const initializeAndRefreshData = async () => {
    setEvaluationsLoading(true)
    try {
      // Fetch ACTIVE Job Postings, Business Opportunities and Technical Consultants in a single call
      const activeResponse = await axios.get("https://raasbackend.vetrinahealthcare.com/JobPostingresultByStatus/?no_cache=" + Date.now())

      const activeJobs = Array.isArray(activeResponse?.data?.jobpostings) ? activeResponse.data.jobpostings : []
      const activeBusiness = Array.isArray(activeResponse?.data?.business_opportunities) ? activeResponse.data.business_opportunities : []
      const activeConsultants = Array.isArray(activeResponse?.data?.technical_consultants) ? activeResponse.data.technical_consultants : []

      const jobsData = activeJobs.map((job) => ({
        value: job.job_id,
        label: `${job.jobtitle} (Job Opening) ${job.job_id} `,
        type: "Job_Opening",
      }))

      const businessData = activeBusiness.map((b) => ({
        value: b.business_id,
        label: `${b.business_title} (Business Opportunity) ${b.business_id} `,
        type: "Business_Opportunity",
      }))

      const consultantsData = activeConsultants.map((c) => ({
        value: c.consultant_id,
        label: `${c.title}   (Technical Consultant) ${c.consultant_id} `,
        type: "Technical_Consultant",
      }))

      const allRolesData = [...jobsData, ...businessData, ...consultantsData]
      setJobRoles(allRolesData)

      // 2. Fetch all evaluation setups (questions and parameters) for every job
      const { questionsData, parametersData } = await fetchAllEvaluationSetups(allRolesData)
      setEvaluationQuestions(questionsData)
      setEvaluationParameters(parametersData)

      // 3. Build the summary for the right-hand panel based on setups
      buildJobEvaluationSummary(questionsData, parametersData, allRolesData)
    } catch (error) {
      console.error("Error initializing data:", error)
      Swal.fire("Error", "Could not fetch initial job role and evaluation data.", "error")
    } finally {
      setEvaluationsLoading(false)
    }
  }

  useEffect(() => {
    initializeAndRefreshData()
  }, [])

  const fetchAllEvaluationSetups = async (allJobs) => {
    const questionsData = {}
    const parametersData = {}

    for (const job of allJobs) {
      if (!job || !job.value || !job.label) continue

      try {
        const url = `https://raasbackend.vetrinahealthcare.com/evaluation_questions/${encodeURIComponent(job.label)}/`
        const questionsResponse = await axios.get(url)
        questionsData[job.value] = questionsResponse.data || []
      } catch (error) {
        console.warn(`No evaluation questions found for job '${job.label}' or error fetching.`)
        questionsData[job.value] = []
      }

      try {
        const parametersResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/job-postings/${job.value}/evaluation-parameters/`)
        parametersData[job.value] = parametersResponse.data || []
      } catch (error) {
        console.warn(`No evaluation parameters found for job ID ${job.value} or error fetching.`)
        parametersData[job.value] = []
      }
    }
    return { questionsData, parametersData }
  }

  const buildJobEvaluationSummary = (questionsByJob, parametersByJob, allJobRoles) => {
    const summary = {}
    const allIdsWithSetups = new Set([...Object.keys(questionsByJob), ...Object.keys(parametersByJob)]);

    allIdsWithSetups.forEach((roleId) => {
      const roleDetails = allJobRoles.find((role) => role.value === roleId);

      if (roleDetails) {
        const generalCount = questionsByJob[roleId]?.length || 0;
        const parameterCount = parametersByJob[roleId]?.length || 0;

        if (generalCount > 0 || parameterCount > 0) {
          summary[roleId] = {
            job_id: roleId,
            job_title: roleDetails.label,
            general_question_count: generalCount,
            parameter_count: parameterCount,
          };
        }
      }
    });
    setJobEvaluationSummary(summary);
  };

const handleEditParameterSubmit = async () => {
  if (!editingEvaluation || !selectedJobEvaluations || editingEvaluationType !== "parameter") return;
  if (!editEvalForm.parameter_text.trim()) {
    Swal.fire("Error", "Parameter text cannot be empty.", "error");
    return;
  }
  
  setIsLoading(true);
  try {
    const jobId = selectedJobEvaluations.job_id;
    const url = `https://raasbackend.vetrinahealthcare.com/job-postings/${jobId}/evaluation-parameters/${editingEvaluation.id}/`;
    const payload = {
      area: editEvalForm.area,
      parameter_text: editEvalForm.parameter_text,
      description: editEvalForm.description,
      is_active: editEvalForm.is_active,
    };
    await axios.put(url, payload);
    Swal.fire("Success!", "Parameter updated successfully.", "success");
    setEditingEvaluation(null);
    setEditingEvaluationType(null);
    // Refresh data
    await initializeAndRefreshData();
  } catch (error) {
    console.error("Error updating parameter:", error);
    Swal.fire("Error!", "Failed to update parameter.", "error");
  } finally {
    setIsLoading(false);
  }
};

// Update the handleEditEvaluation function to properly initialize the form
const handleEditEvaluation = (evaluation, type) => {
  if (type !== "parameter") return;
  setEditingEvaluation(evaluation);
  setEditingEvaluationType(type);
  setEditEvalForm({
    question_text: "",
    answers: ["", "", "", ""],
    correct_answer_index: 0,
    area: evaluation.area || "CORE_COMPETENCIES",
    parameter_text: evaluation.parameter_text || "",
    description: evaluation.description || "",
    is_active: evaluation.is_active !== undefined ? evaluation.is_active : true,
  });
};

  const handleUpdateEvaluation = async () => {
    if (!editingEvaluation || !selectedJobEvaluations || editingEvaluationType !== "parameter") return
    setIsLoading(true)
    try {
      const jobId = selectedJobEvaluations.job_id
      const url = `https://raasbackend.vetrinahealthcare.com/job-postings/${jobId}/evaluation-parameters/${editingEvaluation.id}/`
      const payload = {
        area: editEvalForm.area,
        parameter_text: editEvalForm.parameter_text,
        description: editEvalForm.description,
        is_active: editEvalForm.is_active,
      }
      await axios.put(url, payload)
      Swal.fire("Success!", "Parameter evaluation updated successfully.", "success")
      setEditingEvaluation(null)
      setEditingEvaluationType(null)
      await initializeAndRefreshData()
    } catch (error) {
      console.error("Error updating evaluation:", error)
      const errorMessage =
        error.response?.data?.detail || JSON.stringify(error.response?.data) || "Failed to update evaluation"
      Swal.fire("Error!", errorMessage, "error")
    } finally {
      setIsLoading(false)
    }
  }

  const handleToggleParameterActiveStatus = async (parameter, jobId) => {
    setIsLoading(true)
    try {
      const url = `https://raasbackend.vetrinahealthcare.com/job-postings/${jobId}/evaluation-parameters/${parameter.id}/`
      const payload = {
        area: parameter.area,
        parameter_text: parameter.parameter_text,
        description: parameter.description === null ? null : parameter.description || "",
        is_active: !parameter.is_active,
      }
      await axios.put(url, payload)
      Swal.fire("Success!", `The parameter has been successfully ${payload.is_active ? "activated" : "deactivated"}.`, "success")
      await initializeAndRefreshData()
    } catch (error) {
      console.error("Error toggling parameter status:", error.response)
      const errorMessage =
        error.response?.data?.detail || JSON.stringify(error.response?.data) || "Failed to update parameter status."
      Swal.fire("Error!", `Operation failed: ${errorMessage}`, "error")
    } finally {
      setIsLoading(false)
    }
  }

  const handleDeleteEvaluation = async (evaluation, type, jobId) => {
    if (type !== "general") {
      Swal.fire("Action Not Allowed", "Parameters can only be activated or deactivated, not deleted here.", "info")
      return
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert the deletion of this general question!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    })
    if (result.isConfirmed) {
      setIsLoading(true)
      try {
        const url = `https://raasbackend.vetrinahealthcare.com/jobs/${jobId}/evaluation-questions/${evaluation.id}/`
        await axios.delete(url)
        Swal.fire("Deleted!", "The general question has been deleted.", "success")
        await initializeAndRefreshData()
      } catch (error) {
        console.error("Error deleting evaluation question:", error)
        const errorDetail = error.response?.data?.detail || JSON.stringify(error.response?.data) || ""
        if (errorDetail.includes("ProtectedError") || errorDetail.includes("protected foreign keys")) {
          Swal.fire({
            icon: "error",
            title: "Deletion Failed",
            text: "This item cannot be deleted because it is currently in use by other records (e.g., an interview evaluation).",
          })
        } else {
          Swal.fire("Error!", "An unknown error occurred while trying to delete.", "error")
        }
      } finally {
        setIsLoading(false)
      }
    }
  }

  const handleEditFormChange = (field, value, index = null) => {
    if (field === "answers" && index !== null) {
      const newAnswers = [...editEvalForm.answers]
      newAnswers[index] = value
      setEditEvalForm((prev) => ({ ...prev, answers: newAnswers }))
    } else {
      setEditEvalForm((prev) => ({ ...prev, [field]: value }))
    }
  }

  const resetFormForMode = (mode) => {
    setQuestion("")
    setArea(PREDEFINED_AREAS[0].value)
    setDescription("")
    if (mode === "interviewAreaEvaluation") {
      setQuestionType("")
      setAnswers([])
      setCorrect(null)
      return
    }
    const defaultType = mode === "candidateQuiz" ? "mcq" : "rating"
    setQuestionType(defaultType)
    if (defaultType === "mcq") {
      setAnswers(["", "", "", ""])
      setCorrect(0)
    } else if (defaultType === "truefalse") {
      setAnswers(["True", "False"])
      setTrueOrFalse("true")
      setCorrect(0)
    } else if (defaultType === "rating") {
      setAnswers([...PREDEFINED_RATING_SCALE])
      setCorrect(null)
    } else {
      setAnswers([""])
      setCorrect(null)
    }
  }

  const handleModeToggle = (newMode) => {
    if (designMode === newMode) return
    if (questions.length > 0) {
      Swal.fire({
        title: "Switch Design Mode?",
        text: "You have unsaved changes. Switching modes will clear the current list. Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, switch!",
      }).then((result) => {
        if (result.isConfirmed) {
          setDesignMode(newMode)
          setQuestions([])
          resetFormForMode(newMode)
          setJobRole("")
          setSelectedPostingType("")
          setSelectedPostingId("")
        }
      })
    } else {
      setDesignMode(newMode)
      setQuestions([])
      resetFormForMode(newMode)
      setJobRole("")
      setSelectedPostingType("")
      setSelectedPostingId("")
    }
  }

  const handleJobRoleChange = (e) => {
    const selectedValue = e.target.value
    setJobRole(selectedValue)

    if (selectedValue) {
      const selectedRole = jobRoles.find((role) => role.value === selectedValue)
      if (selectedRole) {
        setSelectedPostingType(selectedRole.type)
        setSelectedPostingId(selectedRole.value)
      }
    } else {
      // Clear if the user deselects
      setSelectedPostingType("")
      setSelectedPostingId("")
    }
  }

  const handleQuestionChange = (e) => setQuestion(e.target.value)
  const handleAreaChange = (e) => setArea(e.target.value)
  const handleDescriptionChange = (e) => setDescription(e.target.value)
  const handleQuestionTypeChange = (e) => {
    const newType = e.target.value
    setQuestionType(newType)
    if (newType === "mcq") {
      setAnswers(["", "", "", ""])
      setCorrect(designMode === "candidateQuiz" ? 0 : null)
    } else if (newType === "truefalse") {
      setAnswers(["True", "False"])
      setTrueOrFalse("true")
      setCorrect(0)
    } else if (newType === "rating") {
      setAnswers([...PREDEFINED_RATING_SCALE])
      setCorrect(null)
    } else {
      setAnswers([""])
      setCorrect(null)
    }
  }

  const handleAnswerChange = (index, e) => {
    const newAnswers = [...answers]
    newAnswers[index] = e.target.value
    setAnswers(newAnswers)
  }

  const handleCorrectChange = (e) => setCorrect(Number.parseInt(e.target.value))
  const handleTrueOrFalseChange = (e) => {
    setTrueOrFalse(e.target.value)
    setCorrect(e.target.value === "true" ? 0 : 1)
  }

  const itemLabel =
    designMode === "candidateQuiz" ? "Question" : designMode === "interviewAreaEvaluation" ? "Parameter" : "Criterion"

  const validateItem = () => {
    if (designMode === "interviewAreaEvaluation") {
      if (!area.trim() || !question.trim()) {
        Swal.fire("Incomplete Fields", `Please fill in both Area and ${itemLabel} Text.`, "warning")
        return false
      }
    } else {
      if (!question.trim()) {
        Swal.fire("Incomplete Fields", `Please enter ${itemLabel} text.`, "warning")
        return false
      }
      if (questionType === "mcq" && answers.some((answer) => !answer.trim())) {
        Swal.fire("Incomplete Fields", "Please fill in all answer options for the MCQ.", "warning")
        return false
      }
    }
    return true
  }

  const addItemToList = () => {
    if (!jobRole) {
      Swal.fire("Select Role", "Please select a job role first.", "warning")
      return
    }
    if (!validateItem()) return
    let newItem
    if (designMode === "interviewAreaEvaluation") {
      newItem = {
        id: Date.now(),
        area: area,
        question: question,
        description: description,
      }
    } else {
      newItem = {
        id: Date.now(),
        question: question,
        questionType: questionType,
      }
      if (questionType === "mcq") {
        newItem.answers = [...answers]
        newItem.correct = designMode === "candidateQuiz" ? correct : null
      } else if (questionType === "truefalse") {
        newItem.answers = ["True", "False"]
        newItem.correct = trueOrFalse === "true" ? 0 : 1
      } else if (questionType === "descriptive") {
        newItem.answers = [""]
        newItem.correct = null
      } else if (questionType === "rating") {
        newItem.answers = [...PREDEFINED_RATING_SCALE]
        newItem.correct = null
      }
    }
    setQuestions([...questions, newItem])
    resetFormForMode(designMode)
    Swal.fire({
      icon: "success",
      title: "Added!",
      text: `${itemLabel} added to the list.`,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1500,
    })
  }

  const removeItem = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setQuestions(questions.filter((_, i) => i !== index))
        Swal.fire("Removed!", "The item has been removed from the list.", "success")
      }
    })
  }

  const submitItems = async () => {
    if (!jobRole) {
      Swal.fire("Select Posting", "Please select a job, business, or consultant role.", "warning")
      return
    }
    if (questions.length === 0) {
      Swal.fire("No Items", `Please add at least one ${itemLabel.toLowerCase()}.`, "warning")
      return
    }
    setIsLoading(true)

    const selectedRole = jobRoles.find(role => role.value === jobRole)
    if (!selectedRole) {
      Swal.fire("Error", "Could not find details for the selected role. Please refresh.", "error")
      setIsLoading(false)
      return
    }

    try {
      if (designMode === "candidateQuiz") {
        const postingType = selectedRole.type
        const postingId = selectedRole.value
        const apiUrl = `https://raasbackend.vetrinahealthcare.com/create_questions/${postingType}/${postingId}/`
        for (const q of questions) {
          let apiQuestionType = ""
          if (q.questionType === "mcq") apiQuestionType = "MCQ"
          else if (q.questionType === "truefalse") apiQuestionType = "TF"
          else if (q.questionType === "descriptive") apiQuestionType = "DESC"
          
          if (!apiQuestionType) continue


          const payload = {
            question_text: q.question,
            question_type: apiQuestionType,
            posting_type: postingType,
            posting_id: postingId,
          }

          if (apiQuestionType !== "DESC") {
            payload.answers = q.answers;
            payload.correct_answer_index = q.correct;
          }

          await axios.post(apiUrl, payload)

        }
      } else if (designMode === "interviewerEvaluation") {
        // New logic for Interviewer Evaluation
        const apiUrl = 'https://raasbackend.vetrinahealthcare.com/save_evaluation/'

        const evaluationDetails = questions.map(q => ({
          question_text: q.question,
          answer_value: null
        }))

        const payload = {
          candidate_name: "N/A - Template",
          candidate_email: "template@example.com",
          interviewer_email: "designer@example.com",
          job_type: selectedRole.type,
          job_posting_id: selectedRole.value,
          evaluation_details: evaluationDetails
        }

        await axios.post(apiUrl, payload)

      } else if (designMode === "interviewAreaEvaluation") {
        // Logic for Interview Parameter
        const apiUrl = `https://raasbackend.vetrinahealthcare.com/job-postings/evaluation-parameters/`
        for (const param of questions) {
          const payload = {
            posting_type: selectedRole.type,
            posting_id: selectedRole.value,
            area: param.area,
            parameter_text: param.question,
            description: param.description,
          }
          await axios.post(apiUrl, payload)
        }
      }

      Swal.fire("Success!", `${itemLabel}s submitted successfully.`, "success")
      setQuestions([])
      // Refresh data after successful submission
      await initializeAndRefreshData()
    } catch (error) {
      console.error("Error submitting items:", error)
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        JSON.stringify(error.response?.data) ||
        "An unknown error occurred."
      Swal.fire(
        "Submission Error!",
        `Failed to submit. Server says: ${errorMessage}`,
        "error"
      )
    } finally {
      setIsLoading(false)
    }
  }

  const handleEdit = (index) => {
    const itemToEdit = questions[index]
    setEditingIndex(index)
    setEditedQuestion(itemToEdit.question)
    if (designMode === "interviewAreaEvaluation") {
      setEditedArea(itemToEdit.area || PREDEFINED_AREAS[0].value)
      setEditedDescription(itemToEdit.description || "")
    } else {
      setEditedQuestionType(itemToEdit.questionType)
      if (itemToEdit.questionType === "mcq") {
        setEditedAnswers([...itemToEdit.answers])
        setEditedCorrect(designMode === "candidateQuiz" ? itemToEdit.correct : null)
      } else if (itemToEdit.questionType === "truefalse") {
        setEditedTrueOrFalse(itemToEdit.correct === 0 ? "true" : "false")
        setEditedCorrect(itemToEdit.correct)
      }
    }
  }

  const handleSave = (index) => {
    let updatedItem
    if (designMode === "interviewAreaEvaluation") {
      if (!editedArea.trim() || !editedQuestion.trim()) {
        Swal.fire("Validation Error", `Area and ${itemLabel} Text cannot be empty.`, "warning")
        return
      }
      updatedItem = {
        ...questions[index],
        area: editedArea,
        question: editedQuestion,
        description: editedDescription,
      }
    } else {
      if (!editedQuestion.trim()) {
        Swal.fire("Validation Error", "Text cannot be empty.", "warning")
        return
      }
      if (editedQuestionType === "mcq" && editedAnswers.some((ans) => !ans.trim())) {
        Swal.fire("Validation Error", "All MCQ options must be filled.", "warning")
        return
      }
      updatedItem = {
        ...questions[index],
        question: editedQuestion,
        questionType: editedQuestionType,
      }
      if (editedQuestionType === "mcq") {
        updatedItem.answers = [...editedAnswers]
        updatedItem.correct = designMode === "candidateQuiz" ? editedCorrect : null
      } else if (editedQuestionType === "truefalse") {
        updatedItem.answers = ["True", "False"]
        updatedItem.correct = editedTrueOrFalse === "true" ? 0 : 1
      } else {
        updatedItem.answers = editedQuestionType === "rating" ? [...PREDEFINED_RATING_SCALE] : [""]
        updatedItem.correct = null
      }
    }
    const newQuestions = [...questions]
    newQuestions[index] = updatedItem
    setQuestions(newQuestions)
    setEditingIndex(null)
    Swal.fire({
      icon: "success",
      title: "Saved!",
      text: "Changes have been updated.",
      timer: 1000,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
    })
  }

  const handleCancelEdit = () => setEditingIndex(null)
  const handleEditedQuestionChange = (e) => setEditedQuestion(e.target.value)
  const handleEditedAreaChange = (e) => setEditedArea(e.target.value)
  const handleEditedDescriptionChange = (e) => setEditedDescription(e.target.value)
  const handleEditedQuestionTypeChange = (e) => {
    const newType = e.target.value
    setEditedQuestionType(newType)
    if (newType === "mcq") {
      setEditedAnswers(
        editedAnswers.length === 4 && editedAnswers.every((a) => typeof a === "string")
          ? [...editedAnswers]
          : ["", "", "", ""],
      )
      setEditedCorrect(designMode === "candidateQuiz" ? 0 : null)
    } else if (newType === "truefalse") {
      setEditedTrueOrFalse("true")
      setEditedCorrect(0)
    }
  }
  const handleEditedAnswerChange = (idx, e) => {
    const newAns = [...editedAnswers]
    newAns[idx] = e.target.value
    setEditedAnswers(newAns)
  }
  const handleEditedCorrectChange = (e) => setEditedCorrect(Number.parseInt(e.target.value))
  const handleEditedTrueOrFalseChange = (e) => {
    setEditedTrueOrFalse(e.target.value)
    setEditedCorrect(e.target.value === "true" ? 0 : 1)
  }

  const handleJobCardClick = (jobData) => {
    setSelectedJobEvaluations(jobData)
    setShowEvaluationDetails(true)
  }

  const pageTitle =
    designMode === "candidateQuiz"
      ? "Candidate Quiz Designer"
      : designMode === "interviewerEvaluation"
      ? "Interviewer Evaluation Form Designer"
      : "Interview Parameter Designer"

  const renderAnswerInputs = () => {
    switch (questionType) {
      case "mcq":
        return (
          <div className="mcq-options">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={answers[0]}
                    onChange={(e) => handleAnswerChange(0, e)}
                    placeholder="Option 1"
                  />
                </div>
                <div className="mb-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={answers[1]}
                    onChange={(e) => handleAnswerChange(1, e)}
                    placeholder="Option 2"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={answers[2]}
                    onChange={(e) => handleAnswerChange(2, e)}
                    placeholder="Option 3"
                  />
                </div>
                <div className="mb-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={answers[3]}
                    onChange={(e) => handleAnswerChange(3, e)}
                    placeholder="Option 4"
                  />
                </div>
              </div>
            </div>
            {designMode === "candidateQuiz" && (
              <div className="row">
                <div className="col-12">
                  <label htmlFor="correct" className="form-label form-label-sm">
                    Correct Option:
                  </label>
                  <select
                    id="correct"
                    className="form-select form-select-sm"
                    value={correct === null ? "" : correct}
                    onChange={handleCorrectChange}
                  >
                    {answers.map((_, i) => (
                      <option key={i} value={i}>
                        Option {i + 1}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>
        )
      case "truefalse":
        return (
          <div className="true-false-options">
            <label className="form-label form-label-sm">Correct Answer:</label>
            <div className="d-flex align-items-center">
              <div className="form-check form-check-inline mb-0">
                <input
                  className="form-check-input"
                  type="radio"
                  name="truefalse"
                  id="true"
                  value="true"
                  checked={trueOrFalse === "true"}
                  onChange={handleTrueOrFalseChange}
                />
                <label className="form-check-label" htmlFor="true">
                  True
                </label>
              </div>
              <div className="form-check form-check-inline mb-0">
                <input
                  className="form-check-input"
                  type="radio"
                  name="truefalse"
                  id="false"
                  value="false"
                  checked={trueOrFalse === "false"}
                  onChange={handleTrueOrFalseChange}
                />
                <label className="form-check-label" htmlFor="false">
                  False
                </label>
              </div>
            </div>
          </div>
        )
      case "descriptive":
        return <p className="text-muted small fst-italic mb-0">Candidate will provide a text-based response.</p>
      case "rating":
        return (
          <div className="rating-options">
            <p className="small text-muted mb-1">This criterion will use the standard rating scale:</p>
            <div className="d-flex flex-wrap gap-1">
              {PREDEFINED_RATING_SCALE.map((item) => (
                <span key={item} className="badge bg-light text-dark border me-1">
                  {item}
                </span>
              ))}
            </div>
          </div>
        )
      default:
        return null
    }
  }

  const renderEditAnswerInputs = () => {
    switch (editedQuestionType) {
      case "mcq":
        return (
          <>
            {editedAnswers.map((ans, idx) => (
              <div key={`edit-mcq-${idx}`} className="mb-1">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={ans}
                  onChange={(e) => handleEditedAnswerChange(idx, e)}
                  placeholder={`Opt ${idx + 1}`}
                />
              </div>
            ))}
            {designMode === "candidateQuiz" && (
              <div className="mt-1 mb-0">
                <label htmlFor="edit-correct" className="form-label form-label-sm visually-hidden">
                  Correct:
                </label>
                <select
                  id="edit-correct"
                  className="form-select form-select-sm"
                  value={editedCorrect === null ? "" : editedCorrect}
                  onChange={handleEditedCorrectChange}
                >
                  {editedAnswers.map((_, i) => (
                    <option key={i} value={i}>
                      Opt {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </>
        )
      case "truefalse":
        return (
          <div className="d-flex align-items-center mt-1">
            <span className="me-2 small text-muted">Correct:</span>
            <div className="form-check form-check-inline mb-0">
              <input
                className="form-check-input"
                type="radio"
                name="edit-truefalse"
                id="edit-true"
                value="true"
                checked={editedTrueOrFalse === "true"}
                onChange={handleEditedTrueOrFalseChange}
              />
              <label className="form-check-label small" htmlFor="edit-true">
                T
              </label>
            </div>
            <div className="form-check form-check-inline mb-0">
              <input
                className="form-check-input"
                type="radio"
                name="edit-truefalse"
                id="edit-false"
                value="false"
                checked={editedTrueOrFalse === "false"}
                onChange={handleEditedTrueOrFalseChange}
              />
              <label className="form-check-label small" htmlFor="edit-false">
                F
              </label>
            </div>
          </div>
        )
      case "descriptive":
        return <p className="text-muted fst-italic small my-1">Text response.</p>
      case "rating":
        return <p className="text-muted fst-italic small my-1">Uses standard rating scale.</p>
      default:
        return null
    }
  }

  const renderAnswerDisplay = (q) => {
    if (q.questionType === "mcq") {
      return (
        <ol type="A" className="mb-0 ps-3 small">
          {q.answers.map((ans, i) => (
            <li
              key={i}
              className={
                designMode === "candidateQuiz" && q.correct !== null && q.correct === i ? "fw-bold text-success" : ""
              }
            >
              {ans}
              {designMode === "candidateQuiz" && q.correct !== null && q.correct === i && " ✔"}
            </li>
          ))}
        </ol>
      )
    } else if (q.questionType === "truefalse") {
      return (
        <p className="mb-0 small">
          Correct: <span className="fw-bold text-success">{q.answers[q.correct]}</span>
        </p>
      )
    } else if (q.questionType === "descriptive") {
      return <p className="text-muted fst-italic mb-0 small">Descriptive (text)</p>
    } else if (q.questionType === "rating") {
      return <p className="text-muted fst-italic mb-0 small">Rating Scale</p>
    }
    return null
  }

  return (
    <div className="d-flex flex-column vh-100">
      <DashNavbar />
      <div className="d-flex flex-grow-1">
        <Sidebar />
        <main className="main flex-grow-1 overflow-hidden">
          <div className="container-fluid py-3 h-100 d-flex flex-column">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="mb-0">{pageTitle}</h2>
              <button className="btn btn-outline-secondary" onClick={() => navigate("/Admindashboard")}>
                <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                Back to Dashboard
              </button>
            </div>

            {/* Mode Toggle */}
            <div className="mb-3 p-2 border rounded bg-light">
              <div className="row align-items-center">
                <div className="col-md-3">
                  <label className="form-label fw-bold mb-0">Design Mode:</label>
                </div>
                <div className="col-md-9">
                  <div className="btn-group w-100" role="group">
                    <button
                      type="button"
                      className={`btn btn-sm ${designMode === "candidateQuiz" ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => handleModeToggle("candidateQuiz")}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} className="me-1" />
                      Candidate Quiz
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${designMode === "interviewerEvaluation" ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => handleModeToggle("interviewerEvaluation")}
                    >
                      <FontAwesomeIcon icon={faClipboardList} className="me-1" />
                      Interviewer Questions
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${designMode === "interviewAreaEvaluation" ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => handleModeToggle("interviewAreaEvaluation")}
                    >
                      <FontAwesomeIcon icon={faTasks} className="me-1" />
                      Post Interview Evaluation
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Area */}
            <div className="row flex-grow-1 overflow-hidden" style={{ minHeight: "400px" }}>
              {/* Left Side - Form and Questions List */}
              <div className="col-lg-8 d-flex flex-column h-100">
                <div className="row flex-grow-1 overflow-hidden">
                  {/* ADD NEW ITEM FORM */}
                  <div className="col-lg-6 d-flex flex-column h-100">
                    <div className="card shadow-sm d-flex flex-column h-100">
                      <div className="card-header bg-white py-2">
                        <h5 className="mb-0">Add New {itemLabel}</h5>
                      </div>
                      <div className="card-body p-3 d-flex flex-column overflow-auto" style={{ minHeight: "300px" }}>
                        <div className="row g-2">
                          <div className={designMode === "interviewAreaEvaluation" ? "col-12" : "col-md-6"}>
                            <label htmlFor="jobRole" className="form-label form-label-sm">
                              Role <span className="text-danger">*</span>
                            </label>
                            <select
                              id="jobRole"
                              className="form-select form-select-sm"
                              value={jobRole}
                              onChange={handleJobRoleChange}
                              required
                            >
                              <option value="">-- Select Job Role --</option>
                              {jobRoles.map((role) => (
                                <option key={role.value} value={role.value}>
                                  {role.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          {designMode !== "interviewAreaEvaluation" && (
                            <div className="col-md-6">
                              <label htmlFor="questionType" className="form-label form-label-sm">
                                Type <span className="text-danger">*</span>
                              </label>
                              <select
                                id="questionType"
                                className="form-select form-select-sm"
                                value={questionType}
                                onChange={handleQuestionTypeChange}
                                required
                              >
                                <option value="mcq">Multiple Choice</option>
                                <option value="truefalse">True/False</option>
                                <option value="descriptive">Descriptive Answer</option>
                                {designMode === "interviewerEvaluation" && <option value="rating">Rating Scale</option>}
                              </select>
                            </div>
                          )}
                        </div>

                        {/* Display for Posting Type and ID */}
                        {jobRole && (
                          <div className="row g-2 mt-2">
                            <div className="col-6">
                              <label className="form-label form-label-sm text-muted mb-0">Posting Type</label>
                              <p className="form-control-plaintext form-control-sm ps-2 py-1 bg-light rounded border mb-0">
                                {selectedPostingType.replace(/_/g, " ")}
                              </p>
                            </div>
                            <div className="col-6">
                              <label className="form-label form-label-sm text-muted mb-0">Posting ID</label>
                              <p className="form-control-plaintext form-control-sm ps-2 py-1 bg-light rounded border mb-0">
                                {selectedPostingId}
                              </p>
                            </div>
                          </div>
                        )}

                        {designMode === "interviewAreaEvaluation" && (
                          <div className="mt-2">
                            <label htmlFor="area" className="form-label form-label-sm">
                              Area <span className="text-danger">*</span>
                            </label>
                            <select
                              id="area"
                              className="form-select form-select-sm"
                              value={area}
                              onChange={handleAreaChange}
                            >
                              {PREDEFINED_AREAS.map((areaOption) => (
                                <option key={areaOption.value} value={areaOption.value}>
                                  {areaOption.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                        <div className="mt-2">
                          <label htmlFor="question" className="form-label form-label-sm">
                            {itemLabel} Text <span className="text-danger">*</span>
                          </label>
                          <textarea
                            id="question"
                            className="form-control form-control-sm"
                            rows="2"
                            value={question}
                            onChange={handleQuestionChange}
                            placeholder={`Enter ${itemLabel.toLowerCase()} text here...`}
                            required
                          />
                        </div>
                        {designMode === "interviewAreaEvaluation" ? (
                          <div className="mt-2 flex-grow-1">
                            <label htmlFor="description" className="form-label form-label-sm">
                              Description <span className="text-muted">(Optional)</span>
                            </label>
                            <textarea
                              id="description"
                              className="form-control form-control-sm"
                              rows="2"
                              value={description}
                              onChange={handleDescriptionChange}
                              placeholder="Provide a brief description or instruction..."
                            />
                          </div>
                        ) : (
                          <div className="mt-2 p-2 border rounded bg-light-subtle">
                            {renderAnswerInputs()}
                          </div>
                        )}
                        <div className="d-grid mt-3 pt-2">
                          <button type="button" className="btn btn-info text-white" onClick={addItemToList}>
                            <FontAwesomeIcon icon={faPlus} className="me-2" />
                            Add {itemLabel} to List
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ITEM LIST */}
                  <div className="col-lg-6 d-flex flex-column h-100">
                    <div className="d-flex flex-column h-100">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="mb-0">
                          {questions.length > 0 ? (
                            <>
                              Current List for{" "}
                              <span className="text-primary">
                                {jobRoles.find((jr) => jr.value.toString() === jobRole.toString())?.label ||
                                  "Selected Role"}
                              </span>
                            </>
                          ) : (
                            "Item List"
                          )}
                        </h5>
                        {questions.length > 0 && (
                          <span className="badge bg-primary rounded-pill">
                            {questions.length} {questions.length === 1 ? itemLabel : `${itemLabel}s`}
                          </span>
                        )}
                      </div>
                      <div className="flex-grow-1 overflow-auto border rounded" style={{ minHeight: "200px" }}>
                        {questions.length > 0 ? (
                          <div className="table-responsive h-100">
                            <table
                              className="table table-hover table-bordered align-middle mb-0"
                              style={{ fontSize: "0.9rem" }}
                            >
                              <thead className="table-light sticky-top" style={{ top: 0, zIndex: 1 }}>
                                {designMode === "interviewAreaEvaluation" ? (
                                  <tr>
                                    <th style={{ width: "5%" }} className="text-center">
                                      #
                                    </th>
                                    <th style={{ width: "40%" }}>{itemLabel} / Area</th>
                                    <th style={{ width: "35%" }}>Description</th>
                                    <th style={{ width: "20%" }} className="text-center">
                                      Actions
                                    </th>
                                  </tr>
                                ) : (
                                  <tr>
                                    <th style={{ width: "5%" }} className="text-center">
                                      #
                                    </th>
                                    <th style={{ width: "35%" }}>{itemLabel}</th>
                                    <th style={{ width: "15%" }} className="text-center">
                                      Type
                                    </th>
                                    <th style={{ width: "25%" }}>Details/Options</th>
                                    <th style={{ width: "20%" }} className="text-center">
                                      Actions
                                    </th>
                                  </tr>
                                )}
                              </thead>
                              <tbody>
                                {questions.map((q, index) => (
                                  <tr key={q.id || index}>
                                    <td className="text-center">{index + 1}</td>
                                    {editingIndex === index ? (
                                      <>
                                        {designMode === "interviewAreaEvaluation" ? (
                                          <>
                                            <td>
                                              <div className="mb-1">
                                                <select
                                                  className="form-select form-select-sm"
                                                  value={editedArea}
                                                  onChange={handleEditedAreaChange}
                                                >
                                                  {PREDEFINED_AREAS.map((areaOption) => (
                                                    <option key={areaOption.value} value={areaOption.value}>
                                                      {areaOption.label}
                                                    </option>
                                                  ))}
                                                </select>
                                              </div>
                                              <textarea
                                                className="form-control form-control-sm"
                                                value={editedQuestion}
                                                onChange={handleEditedQuestionChange}
                                                rows="2"
                                              />
                                            </td>
                                            <td>
                                              <textarea
                                                className="form-control form-control-sm"
                                                value={editedDescription}
                                                onChange={handleEditedDescriptionChange}
                                                rows="3"
                                              />
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td>
                                              <textarea
                                                className="form-control form-control-sm"
                                                value={editedQuestion}
                                                onChange={handleEditedQuestionChange}
                                                rows="3"
                                              />
                                            </td>
                                            <td className="text-center">
                                              <select
                                                className="form-select form-select-sm"
                                                value={editedQuestionType}
                                                onChange={handleEditedQuestionTypeChange}
                                              >
                                                <option value="mcq">MCQ</option>
                                                <option value="truefalse">T/F</option>
                                                <option value="descriptive">Desc.</option>
                                                {designMode === "interviewerEvaluation" && (
                                                  <option value="rating">Rating</option>
                                                )}
                                              </select>
                                            </td>
                                            <td className="small">{renderEditAnswerInputs()}</td>
                                          </>
                                        )}
                                        <td className="text-center">
                                          <div className="btn-group btn-group-sm">
                                            <button
                                              className="btn btn-success"
                                              onClick={() => handleSave(index)}
                                              title="Save"
                                            >
                                              <FontAwesomeIcon icon={faCheck} />
                                            </button>
                                            <button
                                              className="btn btn-secondary"
                                              onClick={handleCancelEdit}
                                              title="Cancel"
                                            >
                                              <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                          </div>
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        {designMode === "interviewAreaEvaluation" ? (
                                          <>
                                            <td>
                                              {q.area && (
                                                <span className="badge bg-secondary mb-1">
                                                  {PREDEFINED_AREAS.find((a) => a.value === q.area)?.label || q.area}
                                                </span>
                                              )}
                                              <div>{q.question}</div>
                                            </td>
                                            <td>
                                              <small className="text-muted">{q.description}</small>
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td>{q.question}</td>
                                            <td className="text-center">
                                              {q.questionType.charAt(0).toUpperCase() + q.questionType.slice(1)}
                                            </td>
                                            <td className="small">{renderAnswerDisplay(q)}</td>
                                          </>
                                        )}
                                        <td className="text-center">
                                          <div className="btn-group btn-group-sm">
                                            <button
                                              className="btn btn-outline-primary"
                                              onClick={() => handleEdit(index)}
                                              title="Edit"
                                            >
                                              <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button
                                              className="btn btn-outline-danger"
                                              onClick={() => removeItem(index)}
                                              title="Remove"
                                            >
                                              <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                          </div>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="card h-100">
                            <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-5">
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="text-muted mb-3"
                                style={{ fontSize: "3rem" }}
                              />
                              <h4>No {itemLabel.toLowerCase()}s added yet</h4>
                              <p className="text-muted mb-0">
                                Use the form on the left to add items for the selected job role and design mode.
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                      {questions.length > 0 && (
                        <div className="d-grid mt-3">
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={submitItems}
                            disabled={!jobRole || isLoading}
                          >
                            {isLoading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Submitting...
                              </>
                            ) : (
                              <>
                                <FontAwesomeIcon icon={faSave} className="me-2" />
                                Submit All for{" "}
                                {jobRoles.find((jr) => jr.value.toString() === jobRole.toString())?.label}
                              </>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side - Evaluations */}
              <div className="col-lg-4 d-flex flex-column h-100">
                <div className="card shadow-sm flex-grow-1">
                  <div className="card-header bg-primary text-white py-2 d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                      <FontAwesomeIcon icon={faClipboardList} className="me-2" />
                      Evaluation Setups
                    </h5>
                    <button
                      className="btn btn-sm btn-outline-light"
                      onClick={initializeAndRefreshData}
                      disabled={evaluationsLoading}
                      title="Refresh Data"
                    >
                      <FontAwesomeIcon icon={faRefresh} />
                    </button>
                  </div>
                  <div className="card-body p-0 d-flex flex-column" style={{ minHeight: "300px" }}>
                    {evaluationsLoading ? (
                      <div className="d-flex flex-grow-1 justify-content-center align-items-center p-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : Object.keys(jobEvaluationSummary).length > 0 ? (
                      <div className="p-3 overflow-auto flex-grow-1">
                        {Object.values(jobEvaluationSummary).map((jobData) => (
                          <div
                            key={jobData.job_id}
                            className="card mb-3 border-0 shadow-sm hover-card"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleJobCardClick(jobData)}
                          >
                            <div className="card-body p-3">
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="card-title mb-1 text-primary">
                                  <FontAwesomeIcon icon={faBuilding} className="me-2" />
                                  {jobData.job_title}
                                </h6>
                              </div>
                              <p className="card-text small text-muted mb-2">ID: {jobData.job_id}</p>
                              <div className="row text-center">
                                <div className="col-6">
                                  <small className="text-muted d-block">General Q's</small>
                                  <span className="badge bg-info">{jobData.general_question_count}</span>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted d-block">Parameters</small>
                                  <span className="badge bg-success">{jobData.parameter_count}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="d-flex flex-column flex-grow-1 justify-content-center align-items-center p-5 text-center">
                        <FontAwesomeIcon icon={faInfoCircle} className="text-muted mb-3" style={{ fontSize: "3rem" }} />
                        <h5>No Evaluation Setups Found</h5>
                        <p className="text-muted mb-0">Use the designer on the left to add questions or parameters.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Evaluation Details Modal */}
            {showEvaluationDetails && selectedJobEvaluations && (
              <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050 }}>
                <div className="modal-dialog modal-xl modal-dialog-scrollable h-100 my-0">
                  <div className="modal-content h-100">
                    <div className="modal-header bg-primary text-white">
                      <h5 className="modal-title">
                        <FontAwesomeIcon icon={faEye} className="me-2" />
                        Evaluations for {selectedJobEvaluations.job_title}
                      </h5>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={() => setShowEvaluationDetails(false)}
                      ></button>
                    </div>
                    <div className="modal-body p-0">
                      <div className="row g-0 h-100">
                        {/* General Evaluations */}
                        <div className="col-md-6 border-end d-flex flex-column">
                          <div className="p-3 bg-info text-white">
                            <h6 className="mb-0">
                              <FontAwesomeIcon icon={faClipboardList} className="me-2" />
                              General Evaluation Questions (
                              {evaluationQuestions[selectedJobEvaluations.job_id]?.length || 0})
                            </h6>
                          </div>
                          <div className="p-3 flex-grow-1 overflow-auto">
                            {evaluationQuestions[selectedJobEvaluations.job_id]?.length > 0 ? (
                              evaluationQuestions[selectedJobEvaluations.job_id].map((question) => (
                                <div key={question.id} className="card mb-3 border-0 shadow-sm">
                                  <div className="card-body p-3">
                                    <div>
                                      <div className="d-flex justify-content-between align-items-start mb-2">
                                        <h6 className="card-title mb-1">
                                          <FontAwesomeIcon icon={faQuestionCircle} className="me-2 text-info" />
                                          Question #{question.id}
                                        </h6>
                                        <div className="btn-group btn-group-sm">
                                          <button
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() =>
                                              handleDeleteEvaluation(
                                                question,
                                                "general",
                                                selectedJobEvaluations.job_id,
                                              )
                                            }
                                            title="Delete General Question"
                                          >
                                            <FontAwesomeIcon icon={faTrash} />
                                          </button>
                                        </div>
                                      </div>
                                      <p className="mb-2 text-justify">
                                        <strong>Question:</strong> {question.question_text}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="text-center p-4">
                                <FontAwesomeIcon
                                  icon={faInfoCircle}
                                  className="text-muted mb-2"
                                  style={{ fontSize: "2rem" }}
                                />
                                <p className="text-muted">No general evaluation questions found.</p>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Parameter Evaluations */}
                       <div className="col-md-6 d-flex flex-column">
  <div className="p-3 bg-success text-white">
    <h6 className="mb-0">
      <FontAwesomeIcon icon={faTasks} className="me-2" />
      Evaluation Parameters ({evaluationParameters[selectedJobEvaluations.job_id]?.length || 0})
    </h6>
  </div>
  <div className="p-3 flex-grow-1 overflow-auto">
    {evaluationParameters[selectedJobEvaluations.job_id]?.length > 0 ? (
      evaluationParameters[selectedJobEvaluations.job_id].map((parameter) => (
        <div key={parameter.id} className="card mb-3 border-0 shadow-sm">
          <div className="card-body p-3">
            {editingEvaluation?.id === parameter.id && editingEvaluationType === "parameter" ? (
              // EDIT FORM for parameter
              <div>
                <div className="mb-3">
                  <label className="form-label">Area</label>
                  <select
                    className="form-select form-select-sm"
                    value={editEvalForm.area}
                    onChange={(e) => setEditEvalForm({...editEvalForm, area: e.target.value})}
                  >
                    {PREDEFINED_AREAS.map((areaOption) => (
                      <option key={areaOption.value} value={areaOption.value}>
                        {areaOption.label}
                      </option>
                    ))}
                  </select>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Parameter Text *</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={editEvalForm.parameter_text}
                    onChange={(e) => setEditEvalForm({...editEvalForm, parameter_text: e.target.value})}
                    placeholder="Enter parameter text"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Description (Optional)</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={editEvalForm.description || ""}
                    onChange={(e) => setEditEvalForm({...editEvalForm, description: e.target.value})}
                    placeholder="Enter description"
                  />
                </div>
                
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="isActiveCheck"
                    checked={editEvalForm.is_active}
                    onChange={(e) => setEditEvalForm({...editEvalForm, is_active: e.target.checked})}
                  />
                  <label className="form-check-label" htmlFor="isActiveCheck">
                    Active
                  </label>
                </div>
                
                <div className="d-flex justify-content-between">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handleEditParameterSubmit}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Saving...
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faSave} className="me-2" />
                        Save Changes
                      </>
                    )}
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setEditingEvaluation(null);
                      setEditingEvaluationType(null);
                    }}
                    disabled={isLoading}
                  >
                    <FontAwesomeIcon icon={faTimes} className="me-2" />
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              // DISPLAY VIEW for parameter
              <div>
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h6 className="card-title mb-1">
                    <FontAwesomeIcon icon={faTasks} className="me-2 text-success" />
                    Parameter #{parameter.id}
                  </h6>
                  <div className="btn-group btn-group-sm">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handleEditEvaluation(parameter, "parameter")}
                      title="Edit"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      className={`btn btn-sm ${
                        parameter.is_active ? "btn-outline-warning" : "btn-outline-success"
                      }`}
                      onClick={() =>
                        handleToggleParameterActiveStatus(
                          parameter,
                          selectedJobEvaluations.job_id,
                        )
                      }
                      title={parameter.is_active ? "Deactivate" : "Activate"}
                    >
                      <FontAwesomeIcon icon={parameter.is_active ? faBan : faCheck} />
                    </button>
                  </div>
                </div>
                <p className="mb-1">
                  <strong>Area:</strong>{" "}
                  <span className="badge bg-light text-dark">
                    {PREDEFINED_AREAS.find((a) => a.value === parameter.area)?.label ||
                      parameter.area}
                  </span>
                </p>
                <p className="mb-1 text-justify">
                  <strong>Parameter:</strong> {parameter.parameter_text}
                </p>
                {parameter.description && (
                  <p className="mb-1 text-justify small text-muted">
                    <strong>Desc:</strong> {parameter.description}
                  </p>
                )}
                <p className="mb-0">
                  <strong>Status:</strong>{" "}
                  <span
                    className={`badge ${parameter.is_active ? "bg-success" : "bg-secondary"}`}
                  >
                    {parameter.is_active ? "Active" : "Inactive"}
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
      ))
    ) : (
      <div className="text-center p-4">
        <FontAwesomeIcon
          icon={faInfoCircle}
          className="text-muted mb-2"
          style={{ fontSize: "2rem" }}
        />
        <p className="text-muted">No evaluation parameters found.</p>
      </div>
    )}
  </div>
</div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowEvaluationDetails(false)
                          setEditingEvaluation(null)
                          setEditingEvaluationType(null)
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>

      <style jsx>{`
        .main {
          overflow-y: auto;
          max-height: calc(100vh - 56px);
        }
        .hover-card:hover {
          transform: translateY(-2px);
          transition: transform 0.2s ease-in-out;
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }
        .text-justify {
          text-align: justify;
        }
        @media (max-width: 768px) {
          .modal-dialog {
            margin: 0.5rem;
          }
          .btn-group {
            flex-wrap: wrap;
          }
          .btn-group .btn {
            margin-bottom: 0.25rem;
          }
        }
      `}</style>
    </div>
  )
}

export default CreateQuestions